import React, { useState, useEffect, useRef } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import PriceCalculator from "@heartinz/gst_india_product_price_calculator";
import TotalCalculator from "@heartinz/checkout_billing_price_validator";
import { CircularProgress, Tooltip } from "@mui/material";
import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
import Messages from "../../../constants/Messages";
import FindStock from "./FindStock";
import UpdateQty from "./UpdateQty";
import UpdatePrice from "./UpdatePrice";
import ChangeModal from "./ChangeModal";
import ModeModal from "./ModeModal";
import AddService from "../service/AddService";
import EditService from "../service/EditService";
import ProfessionalGSTInvoice from "../../../utils/print/a4Invoices/ProfessionalGSTInvoice";
import AddRecharge from "../recharge/AddRecharge";
import EditRecharge from "../recharge/EditRecharge";
import DateConverter from "@heartinz/date_and_time_processor";
import { usePermission } from "../../../context/PermissionContext";
import AddProductSearch from "./AddProductSearch";
import EditCutomer from "../customer/EditCustomer";
import ProductNoteModal from "./Note";
import AddCustomer from "../customer/AddCustomer";
import { useAuth } from "../../../context/AuthProvider";
import { useContextApi } from "../../../context/ContextApi";
import ListFavouriteProduct from "./ListFavouriteProduct";
import uRLs from "../../../utils/baseUtils";
import { getOS } from "../../../utils/getOs";
import SearchInput from "../../../constants/SearchInput";
import InvoiceTempPreview from "../settings/Invoice/InvoiceTempPreview";
import { getAllPriceList, unitScale } from "@heartinz/finance";
import { distributeDiscountToItems } from "@heartinz/finance";
import RemarkModal from "./Remark";
import ProductSearchList from "../../../constants/ProductSearchList";
import ProjectSale from "./ProjectSale";
import GetServerLiveTime from "../../../constants/GetServerLiveTime";
import PaymentMethod from "./PaymentMethod";
import { capitalizeFirstLetter } from "../../../utils/print/a4Invoices/common/invoiceUtils";
import TemplateModalLayout from "../../../templates/modules/TemplateModalLayout";
import { formatCurrencyFun } from "../../../utils/formatCurrencyFunc";
import {
  AddIcon,
  BarcodeIcon,
  CalendarIcon,
  CartIcon,
  CheckIcon,
  ChevronRightIcon,
  CircleIcon,
  DeleteIcon,
  EditIcon,
  LineDoubleIcon,
  MinusIcon,
  NotepadIcon,
  OfferIcon,
  RecentIcon,
  RemoveIcon,
  SearchIcon,
  StarIcon,
  XIcon,
} from "../../../constants/Icons";
import { useLocation } from "react-router-dom";
const Sale = ({ isActive, mode = "SALE" }) => {
  const { checkNetwork } = useNetwork();
  const {
    activeStoreModules,
    hasModulePermission,
    permission,
    blockedPermissions,
    viewOption,
    customerGroups,
    globelPopupOpen,
    storeSettings,
  } = usePermission();
  const { updateSettings } = useAuth();
  const {
    handleSuggestEstimate,
    estimateSuggest,
    setEstimateSuggest,
    handleSuggestService,
    serviceNameSuggest,
    setServiceNameSuggest,
    customerSearchTerm,
    customerSuggestions,
    setCustomerSearchTerm,
    isCustomerData,
    setCustomerData,
    handleCustomerSearch,
    setCustomerSuggestions,
  } = useContextApi();
  const showAlert = useShowAlert();
  const serverTime = GetServerLiveTime();
  const hasFetched = useRef(false);
  const location = useLocation(); 

  const {
    preSaleId,
    Data: preSaleData,
    convertToSale,    
  } = location.state || {};

  const isConvertingPreSale = useRef(false);
  const previousPreSaleIdRef = useRef(null);
  const [isPreLoading, setPreLoading] = useState(false);

  // const [cart, setCart] = useState([]);
  const [pendingSaleId, setPendingSaleId] = useState(null);
  const [barcodeSearchTerm, setBarcodeSearchTerm] = useState("");
  const [productSearchTerm, setProductSearchTerm] = useState("");
  const [productSuggestions, setProductSuggestions] = useState([]);
  const barcodeRef = useRef(null);
  const suggestionsRef = useRef(null);
  const customerSuggestionsRef = useRef(null);
  const [isbtnLoading, setButtonLoading] = useState(false);
  const [error, setErrors] = useState({});
  const [numberSuggest, setNumberSuggest] = useState([]);
  // const [customerSearchTerm, setCustomerSearchTerm] = useState("");
  // const [customerSuggestions, setCustomerSuggestions] = useState([]);
  // const [isCustomerLoading, setIsCustomerLoading] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [totalPayable, setTotalPayable] = useState(0);
  const [totalMRP, setTotalMRP] = useState(0);
  // const [totalDiscount, setTotalDiscount] = useState(0);
  const [totalSaleprice, setTotalSalePrice] = useState(0);
  const [totalSoldprice, setTotalSoldPrice] = useState(0);
  const [totalTaxamount, setTotalTaxAmount] = useState(0);
  const [totalBaseprice, setTotalBasePrice] = useState(0);
  const [totalQty, setTotalQuantity] = useState(0);
  const [totalSaleRes, setSaleTotals] = useState(0);
  const [totalSoldRes, setSoldTotals] = useState(0);
  const [isSaleModalOpen, setSaleModalOpen] = useState(false);
  const [data, setSaleData] = useState(null);
  const [cash, setCash] = useState(0);
  const [card, setCard] = useState(0);
  const [online, setOnline] = useState(0);
  const [upi, setUpi] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [paylater, setPaylater] = useState(0);
  const [totalPaid, setTotalPaid] = useState(0);
  const [balance, setBalance] = useState(totalPayable);
  const [isStockModalOpen, setStockModalOpen] = useState(false);
  const [isStockData, setStockData] = useState(null);
  const [isSoldPirceModalOpen, setSoldPriceModalOpen] = useState(false);
  const [isProductData, setProductData] = useState(null);
  const [isQuantityData, setQunatityItem] = useState(null);
  const [isQuantityIndex, setQunatityIndex] = useState(null);
  const [isQuantityModalOpen, setQuantityModalOpen] = useState(false);
  // const [reachargeSuggest, setRechargeSuggest] = useState([]);
  const [recentData, setRecentData] = useState([]);
  const [noteSuggest, setNoteSuggest] = useState([]);
  const [addGroupload, setAddGroupLoad] = useState(false);
  const [addNewGroupOpen, setNewGroupOpen] = useState(false);
  const [newGroupName, setNewGroupName] = useState(null);
  const [selectTermalOption, setSelectTermalOption] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const templateId = storeSettings?.invoiceSettings?.template?.templateId;
  const [isChangeModalOpen, setChangeModalOpen] = useState(false);
  const [isChangeData, setChangeData] = useState({});
  const [insufficientStockItems, setInsufficientStockItems] = useState([]);
  const [isModeModalOpen, setModeModalOpen] = useState(false);
const hasInsufficientStock =
  Array.isArray(insufficientStockItems) &&
  insufficientStockItems.length > 0;
  const [isCustomerModalOpen, setCustomerModalOpen] = useState(false);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [isEditData, setEditData] = useState(null);
  const [isBtnLoading, setBtnLoading] = useState(false);
  const [noteModalOpen, setNoteModalOpen] = useState(false);
  const [currentNoteProduct, setCurrentNoteProduct] = useState(null);

  const [isServiceModalOpen, setServiceModalOpen] = useState(false);
  const [isProductModalOpen, setProductModalOpen] = useState(false);
  const [isRecharageModalOpen, setRecharageModelOpen] = useState(false);
  const [isEditRechargeModelOpen, setEditRechargeModelOpen] = useState(false);
  const [isEditRechargeData, setEditRechargeData] = useState(null);
  const [isEditSalePriceData, setEditSalePriceData] = useState(null);
  const [isEditSalePriceModelOpen, setEditSalePriceModelOpen] = useState(false);
  const [isEditStockPriceData, setEditStockPriceData] = useState(null);
  const [isEditServiceModalOpen, setEditServiceModalOpen] = useState(false);
  const [isServiceData, setServiceData] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const suggestionRefs = useRef([]);
  const cashRef = useRef(null);
  const cardRef = useRef(null);
  const onlineRef = useRef(null);
  const upiRef = useRef(null);
  const paylaterRef = useRef(null);
  const buttonRef = useRef(null);
  const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);
  const [showProductDropdown, setShowProductDropdown] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [lastSale, setLastSale] = useState(null);
  const [categories, setCategories] = useState([]);
  const dropdownRef = useRef();
  const debounceTimerRef = useRef(null);
  const controllerRef = useRef(null);
  const requestIdRef = useRef(0);
  const [groupName, setGroupName] = useState(customerGroups);
  const [projectId, setProjectId] = useState("");
  const [resetProject, setResetProject] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [offerEnabled, setOfferEnabled] = useState(false);

  const [remark, setRemark] = useState("");
  const [remarkInput, setRemarkInput] = useState("");
  const [remarkModalOpen, setRemarkModalOpen] = useState(false);

  const [isFavouriteProductModel, setFavouriteProductModel] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [shortcutKey, setShortcutKey] = useState("Ctrl + F");
  const [favouriteProducts, setFavouriteProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isViewModalOpen, setViewModalOpen] = useState(false);
  const [overallDiscount, setOverallDiscount] = useState("");
  const [overallDiscountApplied, setOverallDiscountApplied] = useState(false);
  const originalItemsRef = useRef([]);
  const originalPayableRef = useRef(0);
  const skipNextGrandTotalChange = useRef(false);
  const isSwitchingCart = useRef(false);
  const [selectedProductIds, setSelectedProductIds] = useState([]);
  const [updatePriceModalOpen, setUpdatePriceModalOpen] = useState(false);

  const [brandSuggest, setBrandSuggest] = useState([]);

  const originalOverallDiscountRef = useRef({
    overallDiscountAmount: 0,
    previousItemDetails: [],
  });

  const initialPaymentData = {
    cash: 0,
    card: 0,
    online: 0,
    upi: 0,
    paylater: 0,
    discount: 0,
    totalPaid: 0,
    balance: 0,
  };

  const [paymentData, setPaymentData] = useState(initialPaymentData);

  useEffect(() => {
    const payObject = {
      cashamount: CurrencyConverter.toSubunit(paymentData.cash || 0, "INR"),
      cardamount: CurrencyConverter.toSubunit(paymentData.card || 0, "INR"),
      onlineamount: CurrencyConverter.toSubunit(paymentData.online || 0, "INR"),
      upiamount: CurrencyConverter.toSubunit(paymentData.upi || 0, "INR"),
      paylateramount: CurrencyConverter.toSubunit(
        paymentData.paylater || 0,
        "INR",
      ),
      discountamount: 0,
    };

    const totalVal = TotalCalculator.validateCheckout(totalPayable, payObject);
    setBalance(totalVal.balance);
    setPaymentData((prev) => ({
      ...prev,
      totalPaid: totalVal.totalPaid,
      balance: totalVal.balance,
    }));
  }, [
    paymentData.cash,
    paymentData.card,
    paymentData.online,
    paymentData.upi,
    paymentData.paylater,
    totalPayable,
  ]);
  // console.log("totalSoldRes", totalSoldRes);
  // console.log("paymentData", paymentData);
  const [paymentModal, setPaymentModal] = useState(false);
  const handlePaymentClose = () => {
    setPaymentData(initialPaymentData);
    setPaymentModal(false);
  };
  const [showFullRemark, setShowFullRemark] = useState(false);
  const favouriteRefs = useRef([]);

  const [carts, setCarts] = useState(() => {
    try {
      const saved = localStorage.getItem("nGbLcart");
      if (saved) {
        return JSON.parse(saved);
      } else {
        return [
          {
            name: "Cart 1",
            isActive: true,
            items: [],
            customer: null,
            projectId: "",
            Remark: "",
            overallDiscount: "",
            overallDiscountApplied: false,
            stockMode: null,
          },
          {
            name: "Cart 2",
            isActive: false,
            items: [],
            customer: null,
            projectId: "",
            Remark: "",
            overallDiscount: "",
            overallDiscountApplied: false,
            stockMode: null,
          },
          {
            name: "Cart 3",
            isActive: false,
            items: [],
            customer: null,
            projectId: "",
            Remark: "",
            overallDiscount: "",
            overallDiscountApplied: false,
            stockMode: null,
          },
          {
            name: "Cart 4",
            isActive: false,
            items: [],
            customer: null,
            projectId: "",
            Remark: "",
            overallDiscount: "",
            overallDiscountApplied: false,
            stockMode: null,
          },
          {
            name: "Cart 5",
            isActive: false,
            items: [],
            customer: null,
            projectId: "",
            Remark: "",
            overallDiscount: "",
            overallDiscountApplied: false,
            stockMode: null,
          },
        ];
      }
    } catch (error) {
      console.error("Error parsing carts from localStorage", error);
      return [
        {
          name: "Cart 1",
          isActive: true,
          items: [],
          customer: null,
          projectId: "",
          Remark: "",
          overallDiscount: "",
          overallDiscountApplied: false,
          stockMode: null,
        },
        {
          name: "Cart 2",
          isActive: false,
          items: [],
          customer: null,
          projectId: "",
          Remark: "",
          overallDiscount: "",
          overallDiscountApplied: false,
          stockMode: null,
        },
        {
          name: "Cart 3",
          isActive: false,
          items: [],
          customer: null,
          projectId: "",
          Remark: "",
          overallDiscount: "",
          overallDiscountApplied: false,
          stockMode: null,
        },
        {
          name: "Cart 4",
          isActive: false,
          items: [],
          customer: null,
          projectId: "",
          Remark: "",
          overallDiscount: "",
          overallDiscountApplied: false,
          stockMode: null,
        },
        {
          name: "Cart 5",
          isActive: false,
          items: [],
          customer: null,
          projectId: "",
          Remark: "",
          overallDiscount: "",
          overallDiscountApplied: false,
          stockMode: null,
        },
      ];
    }
  });
  const date = serverTime;
  const isofor = date.toISOString();
  const currentDate = DateConverter.ISOToDisplayFormat(
    DateConverter.convertToTimeZone(isofor, "Asia/Kolkata"),
  ).date;
  // const currentDate = new Intl.DateTimeFormat("en-US", {
  //   day: "2-digit",
  //   month: "short",
  //   year: "numeric",
  // }).format(new Date());

  useEffect(() => {
    const savedCart = localStorage.getItem("nGbLcart");
    if (savedCart) {
      try {
        setCarts(JSON.parse(savedCart));
      } catch (error) {
        setCarts([]);
      }
    }
  }, []);

  useEffect(() => {
    if (carts.length > 0) {
      localStorage.setItem("nGbLcart", JSON.stringify(carts));
    }
  }, [carts]);

  useEffect(() => {
    const active = carts.find((cart) => cart.isActive);
    if (active && Array.isArray(active.items)) {
      calculateTotal(active);
    }
  }, [carts]);

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    var cashAmt = CurrencyConverter.toSubunit(cash || 0, "INR");
    var cardAmt = CurrencyConverter.toSubunit(card || 0, "INR");
    var upiAmt = CurrencyConverter.toSubunit(upi || 0, "INR");
    var disAmt = CurrencyConverter.toSubunit(discount || 0, "INR");
    var onlineAmt = CurrencyConverter.toSubunit(online || 0, "INR");
    var paylaterAmt = CurrencyConverter.toSubunit(paylater || 0, "INR");
    var payObject = {
      cashamount: cashAmt,
      cardamount: cardAmt,
      onlineamount: onlineAmt,
      discountamount: disAmt,
      upiamount: upiAmt,
      paylateramount: paylaterAmt,
    };
    var totalVal = TotalCalculator.validateCheckout(totalPayable, payObject);
    setTotalPaid(totalVal.totalPaid);
    setBalance(totalVal.balance);
    if (totalVal.balance < 0) {
      setPaylater(0);
    }
  }, [cash, card, online, upi, discount, paylater, totalPayable]);

  const switchCart = (index) => {
    isSwitchingCart.current = true;

    const newCarts = carts.map((cart, i) => ({
      ...cart,
      isActive: i === index,
    }));
    const hasActive = newCarts.some((cart) => cart.isActive);
    if (!hasActive) {
      newCarts[0].isActive = true;
    }
    setCarts(newCarts);
    localStorage.setItem("nGbLcart", JSON.stringify(newCarts));
    const activeCart = newCarts.find((cart) => cart.isActive);
    setSelectedCustomer(activeCart?.customer || null);
    setProjectId(activeCart?.projectId || "");
    setRemark(activeCart?.Remark || "");
    setRemarkInput(activeCart?.Remark || "");
    setOverallDiscount(activeCart?.overallDiscount || "");
    setOverallDiscountApplied(activeCart?.overallDiscountApplied || false);
    setCash(0);
    setCard(0);
    setOnline(0);
    setUpi(0);
    setDiscount(0);
    setPaylater(0);
    setTotalPaid(0);
    setBalance(0);
    setChangeData({});
    calculateTotal(activeCart);
  };
  // console.log("overallDiscountApplied", overallDiscountApplied);
  const updateActiveCart = (updateFn) => {
    setCarts((prevCarts) => {
      const updatedCarts = prevCarts.map((cart) => {
        if (cart.isActive) {
          return updateFn(cart);
        }
        return cart;
      });
      localStorage.setItem("nGbLcart", JSON.stringify(updatedCarts));
      return updatedCarts;
    });
  };

  const handleProjectSelect = (project) => {
    updateActiveCart((cart) => ({
      ...cart,
      projectId: project,
    }));
  };

  const handleSuggestNote = async () => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/product/note/suggestion?language=en`,
      );

      setNoteSuggest(response.data.results || []);
      // setShowNotePopup(true);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }
  };

  const handleBrandSuggest = async () => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/product/brand/suggestion`,
      );
      const result = response?.data?.results;
      setBrandSuggest(result);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }
  };

  const handleRecentSales = () => {
    const stored = localStorage.getItem("recentSales");
    if (stored) {
      try {
        setLastSale(JSON.parse(stored));
        setShowDropdown(true);
      } catch (error) {
        console.error("Failed to parse last sale:", error);
        setLastSale(null);
        setShowDropdown(false);
      }
    } else {
      setLastSale(null);
      setShowDropdown(true);
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleView = async (saleId) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(`module/sale/${saleId}`);
      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return null;
    }
  };

  const handleRecentView = async (selectedSale) => {
    try {
      const data = await handleView(selectedSale._id);
      if (data) {
        setSaleData(data);
        setSaleModalOpen(true);
        setShowDropdown(false);
        setViewModalOpen(true);
      }
    } catch (error) {
      console.error("Error fetching view data:", error);
    } finally {
    }
  };

  const fetchFavouriteProducts = async () => {
    try {
      setLoading(true);
      const response = await AxiosInstance.get("module/product/favourite");
      // Response shape: { results: [ { productIds: [...] } ] }
      const results = response.data?.results;
      setFavouriteProducts(results);
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setLoading(false);
    }
  };

  const handleBarcodeSearch = async (code) => {
    setBarcodeSearchTerm(code);

    if (code.trim() === "") return; // skip if empty

    try {
      setPreLoading(true);
      if (!checkNetwork()) return;

      const response = await AxiosInstance.get(
        `module/product/code?code=${code}`,
      );

      const product = response.data.results;

      if (product) {
        // Directly handle selection — no suggestions list
        handleSelectProduct(product);
      } else {
        showAlert("warning", "No product found for this barcode");
      }
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setBarcodeSearchTerm(""); // clear after scan
      setPreLoading(false);
    }
  };

  const handleProductSearch = (term) => {
    if (term.trim() === "") {
      setProductSuggestions([]);
      return;
    }

    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    if (controllerRef.current) {
      controllerRef.current.abort();
    }

    debounceTimerRef.current = setTimeout(async () => {
      try {
        if (!checkNetwork()) return;

        setPreLoading(true);

        controllerRef.current = new AbortController();
        const currentId = ++requestIdRef.current;

        const response = await AxiosInstance.get(
          `module/product/search-hybrid-active?searchtxt=${term}`,
          { signal: controllerRef.current.signal },
        );

        if (currentId === requestIdRef.current) {
          // ✅ Remove duplicate barcode values
          const uniqueSuggestions = (response.data.results || []).filter(
            (item, index, self) =>
              index ===
              self.findIndex(
                (p) => p.code?.toString() === item.code?.toString(),
              ),
          );

          setProductSuggestions(uniqueSuggestions);
          setHighlightedIndex(0);
        }
      } catch (error) {
        if (error.name !== "CanceledError" && error.name !== "AbortError") {
          handleError(error, showAlert);
        }
      } finally {
        setPreLoading(false);
      }
    }, 200);
  };
  const handleSelectProduct = async (product, fromModal = false) => {
    try {
      setProductSearchTerm("");
      setProductSuggestions([]);

      if (fromModal) {
        handleProductClose();

        // If UpdatePrice has its own close function, call it here too
        handleUpdatePriceClose?.();
      }

      setSelectedProductIds((prev) =>
        prev.includes(product._id) ? prev : [...prev, product._id],
      );

      const response = await AxiosInstance.get(
        `module/product/view-product/${product._id}`,
      );

      const productDetails = response.data.results;

      if (productDetails.isStock) {
        handleStock(productDetails);
      } else {
        setProductData(productDetails);
        setSoldPriceModalOpen(true);
      }
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const handleUpdatePriceClose = () => {
    setUpdatePriceModalOpen(false);
  };

  const recheckSelectedProducts = async (stockData) => {
    if (!selectedProductIds.length) return;

    try {
      const updatedProducts = [];

      for (const productId of selectedProductIds) {
        const response = await AxiosInstance.get(
          `module/product/view-product/${productId}`,
        );

        const product = response.data.results;

        if (product) {
          updatedProducts.push(product);
        }
        handleProductClose();
      }

      // Start from first product again
      if (updatedProducts.length > 0) {
        const firstProduct = updatedProducts[0];

        if (firstProduct.isStock) {
          handleStock(firstProduct);
        } else {
          setProductData(firstProduct);
          setSoldPriceModalOpen(true);
        }
      }
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const handleStockChanged = async (stockData) => {
    handleProductClose();
    await recheckSelectedProducts(stockData);
  };

  const handleStock = async (product) => {
    try {
      if (!checkNetwork()) return;

      const activeCart = carts.find((cart) => cart.isActive);

      if (!activeCart) return;

      let stockMode = activeCart.stockMode;

      // Only read the setting when this sale/cart has no products yet
      if (!activeCart.items || activeCart.items.length === 0) {
        stockMode = viewOption("saleSettings", "isGroupedStock")
          ? "GROUPED"
          : "INDIVIDUAL";

        // Lock the mode for this sale
        updateActiveCart((cart) => ({
          ...cart,
          stockMode,
        }));
      }

      const isGroupedStock = stockMode === "GROUPED";

      const endpoint = isGroupedStock
        ? `module/stock/grouped/${product._id}`
        : `module/stock/${product._id}`;

      const response = await AxiosInstance.get(endpoint);

      let stockArray = response.data.results || [];

      if (!isGroupedStock) {
        // module/stock API
        stockArray = stockArray.map((item) => ({
          totalStockLeft: item.stockLeft,
          totalStockLeftUnit: item.stockLeftUnit,
          note: product.note || "",
          isStockList: true,
          landingcost: item.landingcost,
          stockLinkId: item.stockLinkId,
          stockData: {
            productid: item.productid,
            saleprice: item.saleprice,
            mrp: item.mrp,
            taxpercentage: item.taxpercentage,
            discount: item.discount,
            baseprice: item.baseprice,
            taxamount: item.taxamount,
            isLock: item.isLock,
            productData: {
              code: item.code,
              hsnsac: item.hsnsac,
              title: item.title,
              unitConfig: item.unitConfig,
            },
          },
        }));
      } else {
        // grouped API
        stockArray = stockArray.map((item) => ({
          ...item,
          note: product.note || "",
          isGroupedStock: true,
        }));
      }

      setStockData(stockArray);
      setStockModalOpen(true);
      setRecentData([]);
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setProductSearchTerm("");
      setProductSuggestions([]);
    }
  };

  const handleAddClick = async (index, productDetails) => {
    setFavouriteProductModel(false);
    setSelectedIndex(index);
    if (!productDetails) return;
    if (productDetails.isStock) {
      try {
        if (!checkNetwork()) return;
        const response = await AxiosInstance.get(
          `module/stock/grouped/${productDetails.productId}`,
        );
        const stockArray = response.data.results || [];
        const stockWithNote = stockArray.map((stock) => ({
          ...stock,
          note: productDetails.note || "",
        }));
        setStockData(stockWithNote);
        setStockModalOpen(true);
        setRecentData([]);
      } catch (error) {
        handleError(error, showAlert);
      } finally {
        setProductSearchTerm("");
        setProductSuggestions([]);
      }
    } else {
      setSoldPriceModalOpen(true);
      setProductData(productDetails);
    }
  };

  const addproduct = async (newData) => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const numericSoldPrice = parseFloat(newData.soldprice);
      const numericQty = parseInt(newData.qty);
      const data = {
        code: newData.code,
        hsnsac: newData.hsnsac,
        title: newData.title,
        mrp: CurrencyConverter.toSubunit(newData.mrp, "INR"),
        saleprice: CurrencyConverter.toSubunit(newData.saleprice, "INR"),
        soldprice: CurrencyConverter.toSubunit(numericSoldPrice, "INR"),
        taxpercentage: newData.taxpercentage,
        discount: CurrencyConverter.toSubunit(newData.discount, "INR"),
        baseprice: CurrencyConverter.toSubunit(newData.baseprice, "INR"),
        taxamount: CurrencyConverter.toSubunit(newData.taxamount, "INR"),
        isLock: newData.isLock,
      };
      const response = await AxiosInstance.post(
        `module/product/add-product`,
        data,
      );
      const addedProduct = response?.data?.results;
      showAlert("success", Messages.SUCCESS.PRODUCT_ADDED);
      const newItem = {
        _id: addedProduct._id,
        code: addedProduct.code,
        hsnsac: addedProduct.hsnsac,
        title: addedProduct.title,
        mrp: addedProduct.mrp,
        saleprice: addedProduct.saleprice,
        soldprice: CurrencyConverter.toSubunit(numericSoldPrice, "INR"),
        taxpercentage: addedProduct.taxpercentage,
        baseprice: addedProduct.baseprice,
        discount: addedProduct.discount,
        taxamount: addedProduct.taxamount,
        isLock: addedProduct.isLock,
        isStock: addedProduct.isStock,
      };
      addProductToCart(newItem, numericQty, false);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const handleSaleItems = async (saleId) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(`module/sale/${saleId}`);
      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return null;
    }
  };

  const addProductToCart = (product, qty, isStock) => {
    if (isStock) {
      handleStockClose();
    } else {
      handleSoldPriceClose();
      editSalePriceClose();
    }

    updateActiveCart((cart) => {
      const prevCart = cart.items;
      const allowDecimal = product.unitConfig && uRLs?.UNIT === "true";

      let updatedQuantity = allowDecimal
        ? Math.max(0.001, parseFloat(qty) || 0)
        : Math.max(1, parseInt(qty) || 0);
      if (product.isStock && typeof product.stockLeft === "number") {
        updatedQuantity = Math.min(updatedQuantity, product.stockLeft);
      }
      let primaryQty = updatedQuantity;
      let secondaryQty = updatedQuantity;

      if (product.unitConfig && uRLs?.UNIT === "true") {
        const scaleRes = unitScale(
          updatedQuantity,
          product.unitConfig,
          product.secondaryUnitSelected ? true : undefined,
        );

        primaryQty = scaleRes.primaryQty;
        secondaryQty = scaleRes.secondaryQty;
      } else {
        primaryQty = updatedQuantity;
        secondaryQty = updatedQuantity;
      }

      let displayUnit = "";
      let displayQty = primaryQty;

      if (product.unitConfig) {
        if (product.secondaryUnitSelected) {
          displayUnit = product.unitConfig.secondaryUnitCode;
          displayQty = secondaryQty;
        } else {
          displayUnit = product.unitConfig.primaryUnitCode;
          displayQty = primaryQty;
        }
      }

      if (
        typeof product.cIndex === "number" &&
        prevCart[product.cIndex] &&
        prevCart[product.cIndex]._id === product._id &&
        prevCart[product.cIndex].mrp === product.mrp &&
        prevCart[product.cIndex].saleprice === product.saleprice &&
        prevCart[product.cIndex].taxpercentage === product.taxpercentage
      ) {
        const updatedSoldRes = getAllPriceList(
          product.mrp,
          product.soldprice,
          product.baseprice,
          product.taxpercentage,
          primaryQty,
          "SALEPRICE",
        );

        const updatedSaleRes = getAllPriceList(
          product.mrp,
          product.saleprice,
          product.baseprice,
          product.taxpercentage,
          primaryQty,
          product.isLock,
        );

        const updatedItems = prevCart.map((item, index) =>
          index === product.cIndex
            ? {
                ...item,
                soldprice: product.soldprice,
                baseprice: updatedSoldRes.basePrice,
                discount: updatedSoldRes.discount,
                taxamount: updatedSoldRes.taxAmount,
                quantity: displayQty,
                unit: displayUnit,
                lineGrandTotal: updatedSoldRes.lineGrandTotal,
                lineTotalBasePrice: updatedSoldRes.lineTotalBasePrice,
                lineTotalDiscount: updatedSoldRes.lineTotalDiscount,
                lineTotalMrp: updatedSoldRes.lineTotalMrp,
                lineTotalSalePrice: updatedSaleRes.lineTotalSalePrice,
                lineTotalSoldPrice: updatedSoldRes.lineTotalSalePrice,
                lineTotalTaxAmount: updatedSoldRes.lineTotalTaxAmount,
              }
            : item,
        );

        return { ...cart, items: updatedItems };
      }

      // === 2. Merge quantity if product already exists ===
      const existingProductIndex = prevCart.findIndex(
        (item) =>
          item._id === product._id &&
          item.mrp === product.mrp &&
          item.saleprice === product.saleprice &&
          item.taxpercentage === product.taxpercentage,
      );

      if (existingProductIndex !== -1) {
        const item = prevCart[existingProductIndex];
        let newQuantity = item.quantity + primaryQty;

        if (product.isStock && typeof product.stockLeft === "number") {
          newQuantity = Math.min(newQuantity, product.stockLeft);
        }

        const updatedSoldRes = getAllPriceList(
          product.mrp,
          product.soldprice,
          product.baseprice,
          product.taxpercentage,
          newQuantity,
          "SALEPRICE",
        );

        const updatedSaleRes = getAllPriceList(
          product.mrp,
          product.saleprice,
          product.baseprice,
          product.taxpercentage,
          newQuantity,
          product.isLock,
        );

        const updatedItems = prevCart.map((it, idx) =>
          idx === existingProductIndex
            ? {
                ...item,
                soldprice: product.soldprice,
                baseprice: updatedSoldRes.basePrice,
                discount: updatedSoldRes.discount,
                taxamount: updatedSoldRes.taxAmount,
                unit: displayUnit,
                quantity: newQuantity,
                lineGrandTotal: updatedSoldRes.lineGrandTotal,
                lineTotalBasePrice: updatedSoldRes.lineTotalBasePrice,
                lineTotalDiscount: updatedSoldRes.lineTotalDiscount,
                lineTotalMrp: updatedSoldRes.lineTotalMrp,
                lineTotalSalePrice: updatedSaleRes.lineTotalSalePrice,
                lineTotalSoldPrice: updatedSoldRes.lineTotalSalePrice,
                lineTotalTaxAmount: updatedSoldRes.lineTotalTaxAmount,
              }
            : it,
        );

        return { ...cart, items: updatedItems };
      }

      // === 3. Add new item ===
      const soldRes = getAllPriceList(
        product.mrp,
        product.soldprice,
        product.baseprice,
        product.taxpercentage,
        primaryQty,
        "SALEPRICE",
      );

      const saleRes = getAllPriceList(
        product.mrp,
        product.saleprice,
        product.baseprice,
        product.taxpercentage,
        primaryQty,
        product.isLock,
      );

      return {
        ...cart,
        items: [
          ...prevCart,
          {
            ...product,
            soldprice: product.soldprice,
            baseprice: soldRes.basePrice,
            discount: soldRes.discount,
            taxamount: soldRes.taxAmount,
            quantity: displayQty,
            unit: displayUnit,
            lineGrandTotal: soldRes.lineGrandTotal,
            lineTotalBasePrice: soldRes.lineTotalBasePrice,
            lineTotalDiscount: soldRes.lineTotalDiscount,
            lineTotalMrp: soldRes.lineTotalMrp,
            lineTotalSalePrice: saleRes.lineTotalSalePrice,
            lineTotalSoldPrice: soldRes.lineTotalSalePrice,
            lineTotalTaxAmount: soldRes.lineTotalTaxAmount,
            imode: "PRODUCT",
          },
        ],
      };
    });
  };

  const updateQuantity = (productId, Uindex, newQty) => {
    if (!isNaN(newQty) && newQty > 0) {
      updateActiveCart((cart) => {
        const updatedItems = cart.items.map((item, index) => {
          if (item._id === productId && index === Uindex) {
            const quantity = parseInt(newQty);

            const saleRes = PriceCalculator.getAllPriceList(
              item.mrp,
              item.saleprice,
              item.baseprice,
              item.taxpercentage,
              quantity,
              item.isLock,
            );
            const soldRes = PriceCalculator.getAllPriceList(
              item.mrp,
              item.soldprice,
              item.baseprice,
              item.taxpercentage,
              quantity,
              "SALEPRICE",
            );

            return {
              ...item,
              baseprice: soldRes.basePrice,
              discount: soldRes.discount,
              taxamount: soldRes.taxAmount,
              quantity,
              lineGrandTotal: soldRes.lineGrandTotal,
              lineTotalBasePrice: soldRes.lineTotalBasePrice,
              lineTotalDiscount: soldRes.lineTotalDiscount,
              lineTotalMrp: soldRes.lineTotalMrp,
              lineTotalSalePrice: saleRes.lineTotalSalePrice,
              lineTotalSoldPrice: soldRes.lineTotalSalePrice,
              lineTotalTaxAmount: soldRes.lineTotalTaxAmount,
            };
          }
          return item;
        });

        return { ...cart, items: updatedItems };
      });
    } else if (newQty <= 0) {
      // Remove the item
      updateActiveCart((cart) => {
        const updatedItems = cart.items.filter((_, index) => index !== Uindex);
        return { ...cart, items: updatedItems };
      });
    }
  };

  const removeItem = (indexToRemove) => {
    updateActiveCart((cart) => {
      const updatedItems = cart.items.filter(
        (_, index) => index !== indexToRemove,
      );

      return {
        ...cart,
        items: updatedItems,
      };
    });
    if (viewOption("saleSettings", "isScanBarcode")) {
      barcodeRef.current?.focus();
    } else {
      suggestionsRef.current?.focus();
    }
  };

  const resetChangeState = () => {
    setChangeData({});
    setChangeModalOpen(false);
  };

  const calculateTotal = (activeCart) => {
    if (
      !activeCart ||
      !Array.isArray(activeCart.items) ||
      activeCart.items.length === 0
    ) {
      setTotalMRP(0);
      setTotalSalePrice(0);
      setTotalSoldPrice(0);
      setTotalBasePrice(0);
      setTotalTaxAmount(0);
      setTotalQuantity(0);
      setSaleTotals(PriceCalculator.getGrandTotal(0, 0, 0, 0));
      setSoldTotals(PriceCalculator.getGrandTotal(0, 0, 0, 0));
      setTotalPayable(0);

      return;
    }
    const items = activeCart.items;
    const totalMrPrice = items.reduce(
      (total, item) => total + (item.lineTotalMrp || 0),
      0,
    );
    const totalSale = items.reduce(
      (total, item) => total + (item.lineTotalSalePrice || 0),
      0,
    );
    const totalSold = items.reduce(
      (total, item) => total + (item.lineTotalSoldPrice || 0),
      0,
    );
    const totalBase = items.reduce(
      (total, item) => total + (item.lineTotalBasePrice || 0),
      0,
    );
    const totalTax = items.reduce(
      (total, item) => total + (item.lineTotalTaxAmount || 0),
      0,
    );
    const totalQty = items.reduce(
      (total, item) => total + (item.quantity || 0),
      0,
    );

    setTotalMRP(CurrencyConverter.toCurrency(totalMrPrice, "INR"));
    setTotalSalePrice(CurrencyConverter.toCurrency(totalSale, "INR"));
    setTotalSoldPrice(CurrencyConverter.toCurrency(totalSold, "INR"));
    setTotalBasePrice(CurrencyConverter.toCurrency(totalBase, "INR"));
    setTotalTaxAmount(CurrencyConverter.toCurrency(totalTax, "INR"));
    setTotalQuantity(totalQty);

    const totalSaleRes = PriceCalculator.getGrandTotal(
      totalMrPrice,
      totalSale,
      totalBase,
      totalTax,
    );

    const totalSoldRes = PriceCalculator.getGrandTotal(
      totalMrPrice,
      totalSold,
      totalBase,
      totalTax,
    );
    setSaleTotals(totalSaleRes);
    setSoldTotals(totalSoldRes);
    setTotalPayable(totalSoldRes.grandtotal);
  };

  const handleSelectCustomer = async (customer) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/customer/details/${customer._id}`,
      );
      const fullCustomer = response.data.results;
      setSelectedCustomer(fullCustomer);
      setCustomerData(fullCustomer);
      setCustomerSearchTerm("");
      setCustomerSuggestions([]);
      updateActiveCart((cart) => ({
        ...cart,
        customer: fullCustomer,
      }));
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const handleOutsideClick = (e) => {
    if (suggestionsRef.current && !suggestionsRef.current.contains(e.target)) {
      setProductSuggestions([]);
      setProductSearchTerm("");
    }
    if (
      customerSuggestionsRef.current &&
      !customerSuggestionsRef.current.contains(e.target)
    ) {
      setCustomerSuggestions([]);
      setCustomerSearchTerm("");
    }
  };

  const handleInputChange = (setValue) => (e) => {
    const value = e.target.value;
    const regex = /^\d*\.?\d{0,2}$/;
    if (regex.test(value)) {
      setValue(value);
    } else {
      setValue(0);
    }
    resetChangeState();
  };

  // const handleOverallDiscount = (value) => {
  //   const discount = Number(value || 0);

  //   setOverallDiscount(discount);

  //   updateActiveCart((cart) => {
  //     if (!cart.items.length) return cart;

  //     const lineItems = cart.items.map((item) => ({
  //       soldPrice: CurrencyConverter.toSubunit(item.soldprice, "INR"),
  //       quantity: item.quantity,
  //       lineTotalSoldPrice: CurrencyConverter.toSubunit(
  //         item.lineTotalSoldPrice,
  //         "INR",
  //       ),
  //     }));
  //     // console.log(lineItems);
  //     // console.log(discount);
  //     const distributedItems = distributeDiscountToItems(
  //       lineItems,
  //       discount,
  //       totalSoldRes.totalsaleprice,
  //     );
  //     // console.log("distributedItems", distributedItems);
  //     const updatedItems = cart.items.map((item, index) => {
  //       const newSoldPrice = distributedItems[index].soldPrice;

  //       const soldRes = getAllPriceList(
  //         item.mrp,
  //         CurrencyConverter.toSubunit(newSoldPrice, "INR"),
  //         item.baseprice,
  //         item.taxpercentage,
  //         item.quantity,
  //         "SALEPRICE",
  //       );

  //       return {
  //         ...item,
  //         soldprice: CurrencyConverter.toSubunit(newSoldPrice, "INR"),
  //         baseprice: soldRes.basePrice,
  //         discount: soldRes.discount,
  //         taxamount: soldRes.taxAmount,
  //         lineGrandTotal: soldRes.lineGrandTotal,
  //         lineTotalBasePrice: soldRes.lineTotalBasePrice,
  //         lineTotalDiscount: soldRes.lineTotalDiscount,
  //         lineTotalMrp: soldRes.lineTotalMrp,
  //         lineTotalSoldPrice: soldRes.lineTotalSalePrice,
  //         lineTotalTaxAmount: soldRes.lineTotalTaxAmount,
  //       };
  //     });

  //     return {
  //       ...cart,
  //       items: updatedItems,
  //     };
  //   });
  // };

  const applyOverallDiscount = () => {
    const discount = Number(overallDiscount);

    updateActiveCart((cart) => {
      if (!cart.items.length) return cart;

      // Save original items once
      originalPayableRef.current = totalSoldRes.grandtotal;
      originalItemsRef.current = structuredClone(cart.items);
      // console.log(originalItemsRef.current);

      originalOverallDiscountRef.current = {
        overallDiscountAmount: CurrencyConverter.toSubunit(discount, "INR"),
        previousItemDetails: cart.items.map((item) => ({
          soldPrice: item.soldprice,
          quantity: item.quantity,
          lineTotalSoldPrice: item.lineTotalSoldPrice,
        })),
      };

      skipNextGrandTotalChange.current = true;

      const lineItems = cart.items.map((item) => ({
        soldPrice: item.soldprice,
        quantity: item.quantity,
        lineTotalSoldPrice: item.lineTotalSoldPrice,
      }));
      // console.log("lineItems", lineItems);
      // console.log("discount", discount);
      const distributedItems = distributeDiscountToItems(
        lineItems,
        CurrencyConverter.toSubunit(discount, "INR"),
        totalSoldRes.totalsaleprice,
      );
      // console.log("distributedItems", distributedItems);
      const updatedItems = cart.items.map((item, index) => {
        const newSoldPrice = distributedItems[index].soldPrice;

        const soldRes = getAllPriceList(
          item.mrp,
          newSoldPrice,
          item.baseprice,
          item.taxpercentage,
          item.quantity,
          "SALEPRICE",
        );

        return {
          ...item,
          soldprice: newSoldPrice,
          baseprice: soldRes.basePrice,
          discount: soldRes.discount,
          taxamount: soldRes.taxAmount,
          lineGrandTotal: soldRes.lineGrandTotal,
          lineTotalBasePrice: soldRes.lineTotalBasePrice,
          lineTotalDiscount: soldRes.lineTotalDiscount,
          lineTotalMrp: soldRes.lineTotalMrp,
          lineTotalSoldPrice: soldRes.lineTotalSalePrice,
          lineTotalTaxAmount: soldRes.lineTotalTaxAmount,
        };
      });

      return {
        ...cart,
        items: updatedItems,
        overallDiscount,
        overallDiscountApplied: true,
      };
    });

    setOverallDiscountApplied(true);
  };


const removeOverallDiscount = () => {
  const originals = structuredClone(originalItemsRef.current || []);

  if (!originals.length) {
    return;
  }

  updateActiveCart((cart) => {
    const restoredItems = originals.map((item) => {
      const quantity = Number(item.quantity || 1);
      const soldPrice = Number(item.soldprice || 0);
      const salePrice = Number(item.saleprice || 0);

      // Recalculate using ORIGINAL sold price
      const soldRes = getAllPriceList(
        item.mrp,
        soldPrice,
        item.baseprice,
        item.taxpercentage,
        quantity,
        "SALEPRICE",
      );

      // Recalculate normal sale price
      const saleRes = getAllPriceList(
        item.mrp,
        salePrice,
        item.baseprice,
        item.taxpercentage,
        quantity,
        item.isLock,
      );

      return {
        ...item,

        quantity,

        // Restore original prices
        soldprice: soldPrice,
        saleprice: salePrice,

        // Recalculate all values
        baseprice: soldRes.basePrice,
        discount: soldRes.discount,
        taxamount: soldRes.taxAmount,

        lineGrandTotal: soldRes.lineGrandTotal,
        lineTotalBasePrice: soldRes.lineTotalBasePrice,
        lineTotalDiscount: soldRes.lineTotalDiscount,
        lineTotalMrp: soldRes.lineTotalMrp,

        lineTotalSalePrice: saleRes.lineTotalSalePrice,
        lineTotalSoldPrice: soldRes.lineTotalSalePrice,
        lineTotalTaxAmount: soldRes.lineTotalTaxAmount,
      };
    });

    return {
      ...cart,
      items: restoredItems,
      overallDiscount: "",
      overallDiscountApplied: false,
    };
  });

  originalItemsRef.current = [];
  originalPayableRef.current = 0;

  setOverallDiscount("");
  setOverallDiscountApplied(false);

  originalOverallDiscountRef.current = {
    overallDiscountAmount: 0,
    previousItemDetails: [],
  };
};




const resetOverallDiscount = () => {
  if (!overallDiscountApplied) return;

  const originals = structuredClone(originalItemsRef.current || []);

  updateActiveCart((cart) => {
    const items = cart.items.map((item) => {
      const original = originals.find(
        (x) =>
          String(x._id) === String(item._id) ||
          x.code === item.code,
      );

      // Newly added product
      if (!original) {
        return item;
      }

      // Keep latest quantity
      const quantity = Number(item.quantity || 1);

      // Restore original sold price
      const soldPrice = Number(original.soldprice || 0);

      // Keep latest sale price
      const salePrice = Number(item.saleprice || 0);

      const soldRes = getAllPriceList(
        item.mrp,
        soldPrice,
        item.baseprice,
        item.taxpercentage,
        quantity,
        "SALEPRICE",
      );

      const saleRes = getAllPriceList(
        item.mrp,
        salePrice,
        item.baseprice,
        item.taxpercentage,
        quantity,
        item.isLock,
      );

      return {
        ...item,

        quantity,
        soldprice: soldPrice,
        saleprice: salePrice,

        baseprice: soldRes.basePrice,
        discount: soldRes.discount,
        taxamount: soldRes.taxAmount,

        lineGrandTotal: soldRes.lineGrandTotal,
        lineTotalBasePrice: soldRes.lineTotalBasePrice,
        lineTotalDiscount: soldRes.lineTotalDiscount,
        lineTotalMrp: soldRes.lineTotalMrp,

        lineTotalSalePrice: saleRes.lineTotalSalePrice,
        lineTotalSoldPrice: soldRes.lineTotalSalePrice,
        lineTotalTaxAmount: soldRes.lineTotalTaxAmount,
      };
    });

    return {
      ...cart,
      items,
      overallDiscount: "",
      overallDiscountApplied: false,
    };
  });

  originalItemsRef.current = [];
  originalPayableRef.current = 0;

  setOverallDiscount("");
  setOverallDiscountApplied(false);

  originalOverallDiscountRef.current = {
    overallDiscountAmount: 0,
    previousItemDetails: [],
  };
};



  const handleCancel = () => {
    const currentActiveIndex = carts.findIndex((cart) => cart.isActive);
    const fallbackIndex = currentActiveIndex === -1 ? 0 : currentActiveIndex;
    const soldCartIndex = carts.findIndex((cart) => cart.isActive);
    // Update carts in state
    const newCarts = carts.map((cart, index) => ({
      ...cart,
      isActive: index === soldCartIndex,
      items: index === soldCartIndex ? [] : cart.items,
      customer: index === soldCartIndex ? null : cart.customer,
      projectId: index === soldCartIndex ? null : cart.projectId,
      Remark: index === soldCartIndex ? null : cart.Remark,
      overallDiscount: index === soldCartIndex ? "" : cart.overallDiscount,
      overallDiscountApplied:
        index === soldCartIndex ? false : cart.overallDiscountApplied,
      stockMode: null,
    }));
    setCarts(newCarts);

    // Update carts in localStorage
    const savedCartData = JSON.parse(localStorage.getItem("nGbLcart")) || [];
    const updatedCartData = savedCartData.map((cart, index) => ({
      ...cart,
      isActive: index === fallbackIndex,
      items: index === fallbackIndex ? [] : cart.items,
      customer: index === fallbackIndex ? null : cart.customer,
      projectId: index === fallbackIndex ? null : cart.projectId,
      Remark: index === fallbackIndex ? null : cart.Remark,
      overallDiscount: index === fallbackIndex ? "" : cart.overallDiscount,
      overallDiscountApplied:
        index === fallbackIndex ? false : cart.overallDiscountApplied,
      stockMode: null,
    }));
    localStorage.setItem("nGbLcart", JSON.stringify(updatedCartData));

    // Clear UI state
    setPaymentData(initialPaymentData);
    setPaymentModal(false);
    setProjectId("");
    setResetProject((prev) => !prev);
    setRemark("");
    setRemarkInput("");
    setCash(0);
    setCard(0);
    setOnline(0);
    setUpi(0);
    setDiscount(0);
    setPaylater(0);
    setTotalPaid(0);
    setBalance(0);
    setChangeData({});
    setCustomerSearchTerm("");
    setCustomerSuggestions([]);
    setSelectedCustomer(null); // ✅ Clear UI
    setPendingSaleId(null);
    setOverallDiscount("");
    setOverallDiscountApplied(false);
    originalOverallDiscountRef.current = {
      overallDiscountAmount: 0,
      previousItemDetails: [],
    };

    // Also clear the original item snapshot
    originalItemsRef.current = [];
  };

  const handleReset = () => {
    handleCancel();
  };

  const handleClose = () => {
    setSaleModalOpen(false);
    setSaleData(null);
  };

  const handleStockClose = () => {
    setStockModalOpen(false);
    if (viewOption("saleSettings", "isScanBarcode")) {
      barcodeRef.current?.focus();
    } else {
      suggestionsRef.current?.focus();
    }
    setStockData(null);
  };
  // console.log("cash", cash);
  // console.log("ONline", online);

  const handleProceed = () => {
    if (
      viewOption("saleSettings", "isCustomerMandatory") &&
      !selectedCustomer
    ) {
      showAlert("error", "Customer is mandatory for this sale");
      customerSuggestionsRef.current?.focus();
      return;
    }

    setPaymentModal(true);
  };

  const handleAdd = async (paymentData) => {
    // console.log("paymentData", paymentData);

    const { paylater, totalPaid } = paymentData;
    // console.log("totalPayable", totalPayable);
    const totalpaid = Number(paymentData.totalPaid || 0);
    // const totalPayable = Number(paymentData.totalPayable || 0);
    const payLater = Number(paymentData.paylater || 0);
    // console.log("totalPaid", totalPaid);
    const activeCart = carts.find((cart) => cart.isActive);
    if (
      !activeCart ||
      !Array.isArray(activeCart.items) ||
      activeCart.items.length === 0
    ) {
      showAlert("warning", Messages.ERROR.EMPTY_CART);
      if (viewOption("saleSettings", "isScanBarcode")) {
        barcodeRef.current?.focus();
      } else {
        suggestionsRef.current?.focus();
      }
      return;
    }
    if (
      viewOption("saleSettings", "isCustomerMandatory") &&
      !selectedCustomer
    ) {
      showAlert("error", "Customer is mandatory for this sale");
      customerSuggestionsRef.current?.focus();
      return;
    }
    if (payLater > 0 && !selectedCustomer) {
      showAlert("error", Messages.ERROR.PAYLATER_ERROR);
      customerSuggestionsRef.current?.focus();
      return;
    }
    if (totalPayable === totalpaid) {
      handleModeConfirm();
    } else if (totalpaid > totalPayable) {
      setChangeModalOpen(true);
    } else {
      cashRef.current?.focus();
      showAlert("warning", Messages.ERROR.INVALID_PAID_AMOUNT);
    }
  };

  const handleQuantity = async (item, Uindex) => {
    setQuantityModalOpen(true);
    setQunatityItem(item);
    setQunatityIndex(Uindex);
  };

  const handleQuantityClose = () => {
    setQuantityModalOpen(false);
    setQunatityItem(null);
    setQunatityIndex(null);
  };

  const handleQuantityUpdate = async (item, Uindex, newQty) => {
    updateQuantity(item, Uindex, newQty);
    handleQuantityClose();
  };

  const handleSoldPriceClose = () => {
    if (viewOption("saleSettings", "isScanBarcode")) {
      barcodeRef.current?.focus();
    } else {
      suggestionsRef.current?.focus();
    }
    setSoldPriceModalOpen(false);
  };

  const editSalePriceClose = () => {
    if (viewOption("saleSettings", "isScanBarcode")) {
      barcodeRef.current?.focus();
    } else {
      suggestionsRef.current?.focus();
    }
    setEditSalePriceModelOpen(false);
  };

  const handleEditRechargeClose = () => {
    if (viewOption("saleSettings", "isScanBarcode")) {
      barcodeRef.current?.focus();
    } else {
      suggestionsRef.current?.focus();
    }
    setEditRechargeModelOpen(false);
  };

  const handleChangeModalClose = () => {
    setChangeModalOpen(false);
  };

  const handleChangeConfirm = (changeData) => {
    if (changeData.changeamount !== 0) {
      setPaylater(0);
    }
    if (
      (paylater > 0 || changeData.paylaterchange > 0) &&
      !selectedCustomer?.customerData._id
    ) {
      showAlert("warning", Messages.ERROR.CUSTOMER_EMPTY);
      customerSuggestionsRef.current?.focus();
      return false;
    }
    setChangeModalOpen(false);
    setChangeData(changeData);
    handleModeConfirm();
  };

  const handleModeConfirm = async () => {
    setModeModalOpen(true);
  };

  const handleModeModalClose = () => {
    if (viewOption("saleSettings", "isScanBarcode")) {
      barcodeRef.current?.focus();
    } else {
      suggestionsRef.current?.focus();
    }
    setModeModalOpen(false);
  };

  const handleProductNote = (item) => {
    setCurrentNoteProduct(item);
    setNoteModalOpen(true);
  };

  const handleProductNoteClose = () => {
    if (viewOption("saleSettings", "isScanBarcode")) {
      barcodeRef.current?.focus();
    } else {
      suggestionsRef.current?.focus();
    }
    setNoteModalOpen(false);
    setCurrentNoteProduct(null);
  };

  const saveProductNote = (note) => {
    if (!currentNoteProduct) return;
    updateActiveCart((cart) => {
      const updatedItems = cart.items.map((item) =>
        item._id === currentNoteProduct._id ? { ...item, note } : item,
      );
      return { ...cart, items: updatedItems };
    });

    const allNotes = Object.values(noteSuggest).flat();

    // Clone existing suggestions safely
    let updatedSuggestions = { ...noteSuggest };

    // If the note does not exist anywhere, add it under General
    if (!allNotes.includes(note)) {
      // If General category doesn't exist, create it
      if (!updatedSuggestions["General"]) {
        updatedSuggestions["General"] = [];
      }

      // Add the new note to General
      updatedSuggestions["General"] = [...updatedSuggestions["General"], note];
    }

    // Update state so UI refreshes immediately
    setNoteSuggest(updatedSuggestions);
    handleProductNoteClose();
  };

  const handleSetTemplate = async (
    templateId,
    selectTermalOption,
    selectHalfA4Option,
    templateTheme,
    show = true,
  ) => {
    if (!checkNetwork()) return;
    try {
      const response = await AxiosInstance.patch(
        `module/storesettings/template`,
        {
          templateId: `${templateId}AND${selectTermalOption}AND${selectHalfA4Option}`,
          templateTheme,
        },
      );
      const results = response.data?.results?.invoiceSettings?.template;
      const id = results.templateId;
      const words = id.split("AND");
      setSelectedOption(words[0]);
      setSelectTermalOption(words[1]);
      setViewModalOpen(false);
      setSaleModalOpen(true);
      updateSettings({
        storeSettings: {
          invoiceSettings: {
            template: {
              templateId: results?.templateId,
              templateTheme: results?.templateTheme,
            },
            signature: results?.signature,
            termsAndConditions: results?.termsAndConditions,
          },
        },
      });
      {
        show && showAlert("success", "Template Selected...");
      }
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  // console.log(
  //   "activeCart",
  //   carts.find((cart) => cart.isActive),
  // );
  // console.log("State projectId:", projectId);

  // const clearOverallDiscount = () => {
  //   setOverallDiscount("");
  //   setOverallDiscountApplied(false);

  //   originalOverallDiscountRef.current = {
  //     overallDiscountAmount: 0,
  //     previousItemDetails: [],
  //   };

  //   originalItemsRef.current = [];
  // };

  const handleAddSale = async (salemode) => {
    const activeCart = carts.find((cart) => cart.isActive);

    if (
      !activeCart ||
      !Array.isArray(activeCart.items) ||
      activeCart.items.length === 0
    ) {
      showAlert("warning", Messages.ERROR.EMPTY_CART);
      return;
    }

    // const saleItems = activeCart.items.map((item) => ({
    //   ...(item.imode === "SERVICE"
    //     ? { serviceId: item._id }
    //     : { _id: item._id }),
    //   code: item.code,
    //   hsnsac: item.hsnsac,
    //   title: item.title,
    //   mrp: item.mrp,
    //   saleprice: item.saleprice,
    //   soldprice: item.soldprice,
    //   taxpercentage: item.taxpercentage,
    //   baseprice: item.baseprice,
    //   isLock: "SALEPRICE",
    //   isStock: item.isStock,
    //   quantity: item.quantity,
    //   description: item.description || "",
    //   imode: item.imode,
    //   walletid: item.walletid || "",
    //   operator: item.operator || "",
    //   number: item.number || "",
    //   note: item.note || "",
    //   serviceByName: item.serviceByName || "",
    // }));

    const isGroupedStock = activeCart.stockMode === "GROUPED";

    const saleItems = activeCart.items.map((item) => {
      const commonFields = {
        title: item.title,
        hsnsac: item.hsnsac || "",
        description: item?.description || "",
        mrp: item.mrp,
        saleprice: item.saleprice,
        soldprice: item.soldprice,
        taxpercentage: item.taxpercentage,
        baseprice: item.baseprice,
        isLock: "SALEPRICE",
        isStock: item.isStock,
        quantity: item.quantity,
        note: item?.note || "",
        imode: item.imode,
        ...(item.unitConfig && {
          unitConfig: item.unitConfig,
        }),
        isSecondaryUnit: item.secondaryUnitSelected,
        ...(!isGroupedStock &&
          item.stockLinkId && {
            stockLinkId: item.stockLinkId,
          }),
      };

      if (item.imode === "SERVICE") {
        return {
          serviceId: item._id,
          serviceByName: item.serviceByName || "",
          ...commonFields,
        };
      }

      if (item.imode === "RECHARGE") {
        return {
          walletid: item.walletid || "",
          operator: item.operator || "",
          number: item.number || "",
          ...commonFields,
        };
      }

      // PRODUCT (default)
      return {
        _id: item._id,
        code: item.code,
        ...commonFields,
      };
    });
    const createSaleData = { salemode: "" + salemode + "" };
   const previousItems =
      activeCart?.items?.length > 0
        ? activeCart.items
        : originalItemsRef.current;
    const saleData = {
      customerid: selectedCustomer?.customerData._id ?? "",
      saleitems: saleItems,
      isGroupedStock,
     ...(activeCart?.projectId && {
  projectId:
    typeof activeCart.projectId === "object"
      ? activeCart.projectId._id
      : activeCart.projectId,
}),
      ...(activeCart.overallDiscountApplied && {
        overallDiscount: {
          overallDiscountAmount: CurrencyConverter.toSubunit(
            Number(activeCart.overallDiscount || 0),
            "INR",
          ),
        
          previousItemDetails: previousItems.map((item) => ({
            soldPrice: item.soldprice,
            quantity: item.quantity,
            lineTotalSoldPrice: item.lineTotalSoldPrice,
          })),
          
        },
      }),
      // totalqty: totalQty,
      // totalmrp: totalSoldRes.totalmrp,
      // totalsaleprice: totalSaleRes.totalsaleprice,
      // totalsoldprice: totalSoldRes.totalsaleprice,
      // totalbaseprice: totalSoldRes.totalbaseprice,
      // totaldiscount: totalSoldRes.totaldiscount,
      // totaltaxamount: totalSoldRes.totaltaxamount,
      // grandtotal: totalSoldRes.grandtotal,
      // sgstamount: totalSoldRes.sgstamount,
      // cgstamount: totalSoldRes.cgstamount,
      // igstamount: totalSoldRes.igstamount,
      // amountinwords: totalSoldRes.amountinwords,
      ...(remark && remark.trim() !== "" && { remark }),
      waveoffamount: 0,
      cashamount: CurrencyConverter.toSubunit(cash || 0, "INR"),
      cardamount: CurrencyConverter.toSubunit(card || 0, "INR"),
      upiamount: CurrencyConverter.toSubunit(upi || 0, "INR"),
      paylateramount: CurrencyConverter.toSubunit(paylater || 0, "INR"),
      // paidamount: totalPaid,
      cardchange: 0,
      onlinechange: 0,
      onlineamount: CurrencyConverter.toSubunit(online || 0, "INR"),
      changeamount: CurrencyConverter.toSubunit(
        isChangeData.changeamount || 0,
        "INR",
      ),
      waveoffchange: CurrencyConverter.toSubunit(
        isChangeData.wavedoffchange || 0,
        "INR",
      ),
      cashchange: CurrencyConverter.toSubunit(
        isChangeData.cashchange || 0,
        "INR",
      ),
      upichange: CurrencyConverter.toSubunit(
        isChangeData.upichange || 0,
        "INR",
      ),
      paylaterchange: CurrencyConverter.toSubunit(
        isChangeData.paylaterchange || 0,
        "INR",
      ),
    };
    setButtonLoading(true);
    try {
      if (!checkNetwork()) return;
      let saleId = pendingSaleId;

      if (!saleId) {
        const response = await AxiosInstance.post(
          `module/sale`,
          createSaleData,
        );
        saleId = response.data.results._id;

        // Save for retry
        setPendingSaleId(saleId);
      }

      saleData.saleid = saleId;
      const saleResp = await AxiosInstance.post(
        `module/sale/add-sale`,
        saleData,
      );
          const createdSaleId = saleResp.data.results._id;
          if (preSaleId) {
               await AxiosInstance.patch(
        `module/presale/update/status/${preSaleId}`,
        {
          saleId: createdSaleId,
        },
      );
    }
      setPendingSaleId(null);
      showAlert("success", Messages.SUCCESS.SALE_ADDED);
      setSaleModalOpen(true);
      setViewModalOpen(true);
      setSaleData(saleResp.data.results);
      const { saleno, createdAt, grandtotal, totalItems, _id } =
        saleResp.data.results;
      const newSaleSummary = { saleno, createdAt, grandtotal, totalItems, _id };
      const previousSales =
        JSON.parse(localStorage.getItem("recentSales")) || [];
      const updatedSales = [newSaleSummary, ...previousSales];
      const trimmedSales = updatedSales.slice(0, 10);
      localStorage.setItem("recentSales", JSON.stringify(trimmedSales));
      setCarts((prevCarts) =>
        prevCarts.map((cart) =>
          cart.isActive
            ? {
                ...cart,
                items: [],
                overallDiscount: "",
                overallDiscountApplied: false,
                stockMode: null,
              }
            : cart,
        ),
      );

      setOverallDiscount("");
      setOverallDiscountApplied(false);

      originalItemsRef.current = [];

      originalOverallDiscountRef.current = {
        overallDiscountAmount: 0,
        previousItemDetails: [],
      };
      handleReset();
    } catch (error) {
       const errorData = error?.response?.data;

      if (
        errorData?.code === "NOT_FOUND" &&
        Array.isArray(errorData?.results)
      ) {
        setInsufficientStockItems(errorData.results);

        showAlert(
          "error",
          `${errorData.results.length} item${
            errorData.results.length > 1 ? "s" : ""
          } have insufficient stock.`,
        );
        setPaymentModal(false);
        setModeModalOpen(false);
        return false;
      }
      handleError(error, showAlert);
      return false;
    } finally {
      setButtonLoading(false);
    }
  };

  const handleCustomerModalOpen = () => {
    setSelectedCustomer(null);
    setCustomerModalOpen(true);
  };

  const handleCustomerModalClose = () => {
    customerSuggestionsRef.current?.focus();
    setCustomerModalOpen(false);
    setCustomerData(null);
  };

  const handleRemoveCustomer = () => {
    setSelectedCustomer(null);
    setCustomerSearchTerm("");
    setCustomerSuggestions([]);
    setShowCustomerDropdown(false);
  };

  const handleCustomerAdd = async (newData) => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        ...newData,
        shippingAddress: {
          addressline1: newData.shippingaddressline1,
          addressline2: newData.shippingaddressline2,
          district: newData.shippingdistrict,
          city: newData.shippingcity,
          state: newData.shippingstate,
          statecode: newData.shippingstatecode,
          country: newData.shippingcountry,
          pincode: newData.shippingpincode,
        },

        ...(newData.contactPersonname?.trim() ||
        newData.contactPersonNumber?.trim()
          ? {
              contactPerson: {
                ...(newData.contactPersonname?.trim() && {
                  name: newData.contactPersonname,
                }),
                ...(newData.contactPersonNumber?.trim() && {
                  number: newData.contactPersonNumber,
                }),
              },
            }
          : {}),
      };
      const response = await AxiosInstance.post(`module/customer`, data);
      showAlert("success", Messages.SUCCESS.CUSTOMER_ADDED);
      const result = response.data.results;
      if (result.name !== newData.name) {
        showAlert(
          "warning",
          `The phone number"${result.phone}" already exists .`,
        );
        // handleCloseModal();
        return true;
      }
      handleResetCustomer();
      handleSelectCustomer(response.data.results);
      return true;
    } catch (error) {
      if (
        error.response &&
        error.response.status === 409 &&
        error.response.data &&
        error.response.data.code === "DUPLICATE_ENTRY"
      ) {
        const errorMessage = error.response.data.message;
        let fieldError = {};

        // if (errorMessage.includes("ReferenceId already exists")) {
        //     fieldError.referenceid = "Reference ID already exists .";
        // }
        if (errorMessage.includes("GST number already exists")) {
          fieldError.gstnumber = "GST number already exists.";
        }

        if (Object.keys(fieldError).length > 0) {
          setErrors((prev) => ({ ...prev, ...fieldError }));
        } else {
          handleError(error, showAlert);
        }

        return false;
      } else {
        handleError(error, showAlert);
        return false;
      }
    } finally {
      setBtnLoading(false);
    }
  };

  const openEditModal = (cItem) => {
    if (
      blockedPermissions("CUSTOMER:viewDetails") ||
      permission === undefined
    ) {
      setEditData(cItem);
      setEditModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleUpdte = async (updatedData) => {
    const editableKeys = [
      "name",
      "phone",
      "email",
      "addressline1",
      "addressline2",
      "city",
      "district",
      "state",
      "pincode",
      "country",
      "gstnumber",
      "pannumber",
      "cinnumber",
      "referenceid",
      "isPayLater",
      "groupid",
      "fssai",
      "tradeName",
      "nickname",
      "contactPersonname",
      "contactPersonNumber",
      "shippingaddressline1",
      "shippingaddressline2",
      "shippingstate",
      "shippingcity",
      "shippingdistrict",
      "shippingpincode",
      "shippingcountry",
      "website",
    ];

    let hasChange = false;
    for (const key of editableKeys) {
      const originalValue = String(isEditData[key] || "");
      const updatedValue = String(updatedData[key] || "");
      if (originalValue !== updatedValue) {
        hasChange = true;
        break;
      }
    }

    if (!hasChange) {
      showAlert("warning", "No changes detected.");
      return false;
    }
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        ...updatedData,
        shippingAddress: {
          addressline1: updatedData.shippingaddressline1,
          addressline2: updatedData.shippingaddressline2,
          district: updatedData.shippingdistrict,
          city: updatedData.shippingcity,
          state: updatedData.shippingstate,
          statecode: updatedData.shippingstatecode,
          country: updatedData.shippingcountry,
          pincode: updatedData.shippingpincode,
        },

        // ✅ Contact Person Object
        ...(updatedData.contactPersonname?.trim() ||
        updatedData.contactPersonNumber?.trim()
          ? {
              contactPerson: {
                ...(updatedData.contactPersonname?.trim() && {
                  name: updatedData.contactPersonname,
                }),
                ...(updatedData.contactPersonNumber?.trim() && {
                  number: updatedData.contactPersonNumber,
                }),
              },
            }
          : {}),
        customerid: updatedData._id,
      };
      const response = await AxiosInstance.patch(
        `module/customer/${updatedData._id}`,
        data,
      );

      showAlert("success", Messages.SUCCESS.CUSTOMER_UPDATED);
      setCustomerData(response.data.results);
      setSelectedCustomer((prev) => ({
        ...prev,
        customerData: response.data.results,
      }));
      closeEditModal();
      return true;
    } catch (error) {
      if (
        error.response &&
        error.response.status === 409 &&
        error.response.data &&
        error.response.data.code === "DUPLICATE_ENTRY"
      ) {
        const errorMessage = error.response.data.message;
        let fieldError = {};

        if (errorMessage.includes("ReferenceId already exists")) {
          fieldError.referenceid = "Reference ID already exists .";
        } else if (errorMessage.includes("GST number already exists")) {
          fieldError.gstnumber = "GST number already exists.";
        }

        if (Object.keys(fieldError).length > 0) {
          setErrors((prev) => ({ ...prev, ...fieldError }));
        } else {
          handleError(error, showAlert);
        }

        return false;
      } else {
        handleError(error, showAlert);
        return false;
      }
    } finally {
      setBtnLoading(false);
    }
  };

  const closeEditModal = () => {
    customerSuggestionsRef.current?.focus();
    setEditData(null);
    setEditModalOpen(false);
  };

  const handleResetCustomer = () => {
    setCustomerModalOpen(false);
    setCustomerData(null);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && customerSearchTerm.trim()) {
      handleCustomerModalOpen();
    }
  };

  const handleServiceOpen = async () => {
    // await handleSuggestEstimate();
    setServiceModalOpen(true);
  };

  const handleServiceClose = () => {
    if (viewOption("saleSettings", "isScanBarcode")) {
      barcodeRef.current?.focus();
    } else {
      suggestionsRef.current?.focus();
    }
    setServiceModalOpen(false);
  };

  const handleProductOpen = async () => {
    try {
      const res = await AxiosInstance.get("/module/quicksale/");
      setCategories(res.data.results);
    } catch (err) {
      console.error("Failed to fetch categories", err);
    }
    setProductModalOpen(true);
  };

  const handleProductClose = () => {
    if (viewOption("saleSettings", "isScanBarcode")) {
      barcodeRef.current?.focus();
    } else {
      suggestionsRef.current?.focus();
    }
    setProductModalOpen(false);
  };

  const handleRechargeOpen = async () => {
    setRecharageModelOpen(true);
  };

  const handleRechargeClose = () => {
    if (viewOption("saleSettings", "isScanBarcode")) {
      barcodeRef.current?.focus();
    } else {
      suggestionsRef.current?.focus();
    }
    setRecharageModelOpen(false);
  };

  const addRechargeToCart = (rechargeData) => {
    const quantity = 1;
    const amount = parseFloat(rechargeData.amount || 0);
    const subunitAmount = CurrencyConverter.toSubunit(amount.toFixed(2), "INR");

    const priceResult = PriceCalculator.getAllPriceList(
      subunitAmount, // mrp
      subunitAmount, // saleprice
      subunitAmount, // baseprice
      0,
      quantity,
      "SALEPRICE",
    );

    const newRecharge = {
      imode: "RECHARGE",
      isLock: rechargeData.isLock,
      isStock: false,
      walletid: rechargeData.walletId,
      title: `Recharge - ${rechargeData.operator} - ${rechargeData.number}`,
      operator: rechargeData.operator,
      number: rechargeData.number,
      wallet: rechargeData.wallet,
      description: rechargeData.note || "recharge",
      quantity,

      mrp: subunitAmount,
      saleprice: subunitAmount,
      soldprice: subunitAmount,
      baseprice: subunitAmount,
      taxpercentage: 0,
      discount: priceResult.discount,
      taxamount: priceResult.taxAmount,

      lineGrandTotal: priceResult.lineGrandTotal,
      lineTotalBasePrice: priceResult.lineTotalBasePrice,
      lineTotalDiscount: priceResult.lineTotalDiscount,
      lineTotalMrp: priceResult.lineTotalMrp,
      lineTotalSalePrice: priceResult.lineTotalSalePrice,
      lineTotalSoldPrice: priceResult.lineTotalSalePrice,
      lineTotalTaxAmount: priceResult.lineTotalTaxAmount,
    };

    updateActiveCart((cart) => {
      let updatedItems;
      if (typeof rechargeData.cIndex === "number") {
        updatedItems = cart.items.map((item, index) =>
          index === rechargeData.cIndex ? newRecharge : item,
        );
      } else {
        updatedItems = [...cart.items, newRecharge];
      }

      return {
        ...cart,
        items: updatedItems,
      };
    });
  };
  // console.log(carts);
  const addServiceToCart = (citem, qty, cMode) => {
    // console.log("citem", citem);
    const newSuggest = {
      _id: citem._id,
      title: citem.title,
      hsnsac: citem.hsnsac,
    };
    setEstimateSuggest((prev) => {
      const exists = prev.some(
        (item) =>
          item.title === newSuggest.title && item.hsnsac === newSuggest.hsnsac,
      );
      return exists ? prev : [...prev, newSuggest];
    });
    if (cMode === "ADD") {
      handleServiceClose();
    } else if (cMode === "EDIT") {
      handleEditServiceClose();
    }
    updateActiveCart((cart) => {
      const updatedQuantity = Math.max(1, Number(qty) || 1);
      const saleRes = getAllPriceList(
        citem.mrp,
        citem.saleprice,
        citem.baseprice,
        citem.taxpercentage,
        updatedQuantity,
        citem.isLock,
      );
      const soldRes = getAllPriceList(
        citem.mrp,
        citem.soldprice,
        citem.baseprice,
        citem.taxpercentage,
        updatedQuantity,
        "SALEPRICE",
      );
      const newServiceItem = {
        ...citem,
        description: citem.description?.trim() || "",
        baseprice: soldRes.basePrice,
        discount: soldRes.discount,
        taxamount: soldRes.taxAmount,
        quantity: updatedQuantity,
        lineGrandTotal: soldRes.lineGrandTotal,
        lineTotalBasePrice: soldRes.lineTotalBasePrice,
        lineTotalDiscount: soldRes.lineTotalDiscount,
        lineTotalMrp: soldRes.lineTotalMrp,
        lineTotalSalePrice: saleRes.lineTotalSalePrice,
        lineTotalSoldPrice: soldRes.lineTotalSalePrice,
        lineTotalTaxAmount: soldRes.lineTotalTaxAmount,
      };
      let updatedItems;

      if (cMode === "EDIT") {
        if (typeof citem.cIndex === "number") {
          updatedItems = cart.items.map((item, idx) =>
            idx === citem.cIndex ? newServiceItem : item,
          );
        } else {
          const existingIndex = cart.items.findIndex(
            (item) => item.uniqueId === citem.uniqueId,
          );

          if (existingIndex !== -1) {
            updatedItems = cart.items.map((item, idx) =>
              idx === existingIndex ? newServiceItem : item,
            );
          } else {
            updatedItems = [...cart.items, newServiceItem];
          }
        }
      } else {
        // ADD mode
        // const existingIndex = cart.items.findIndex(
        //   (item) => item._id === citem._id,
        // );

        // if (existingIndex !== -1) {
        //   updatedItems = [...cart.items];

        //   const newQty =
        //     (Number(updatedItems[existingIndex].quantity) || 1) +
        //     updatedQuantity;

        //   const saleRes = getAllPriceList(
        //     citem.mrp,
        //     citem.saleprice,
        //     citem.baseprice,
        //     citem.taxpercentage,
        //     newQty,
        //     citem.isLock,
        //   );

        //   const soldRes = getAllPriceList(
        //     citem.mrp,
        //     citem.soldprice,
        //     citem.baseprice,
        //     citem.taxpercentage,
        //     newQty,
        //     "SALEPRICE",
        //   );

        //   updatedItems[existingIndex] = {
        //     ...updatedItems[existingIndex],
        //     quantity: newQty,
        //     baseprice: soldRes.basePrice,
        //     discount: soldRes.discount,
        //     taxamount: soldRes.taxAmount,
        //     lineGrandTotal: soldRes.lineGrandTotal,
        //     lineTotalBasePrice: soldRes.lineTotalBasePrice,
        //     lineTotalDiscount: soldRes.lineTotalDiscount,
        //     lineTotalMrp: soldRes.lineTotalMrp,
        //     lineTotalSalePrice: saleRes.lineTotalSalePrice,
        //     lineTotalSoldPrice: soldRes.lineTotalSalePrice,
        //     lineTotalTaxAmount: soldRes.lineTotalTaxAmount,
        //   };
        // } else {
        //   updatedItems = [...cart.items, newServiceItem];
        // }
        updatedItems = [
          ...cart.items,
          {
            ...newServiceItem,
            uniqueId: crypto.randomUUID(), // ensure each row is unique
          },
        ];
      }
      return {
        ...cart,
        items: updatedItems,
      };
    });
  };

  const editItem = async (cItem, index) => {
    setServiceData({
      ...cItem,
      mrp: CurrencyConverter.toCurrency(cItem.mrp, "INR"),
      saleprice: CurrencyConverter.toCurrency(cItem.saleprice, "INR"),
      discount: CurrencyConverter.toCurrency(cItem.discount, "INR"),
      baseprice: CurrencyConverter.toCurrency(cItem.baseprice, "INR"),
      taxamount: CurrencyConverter.toCurrency(cItem.taxamount, "INR"),
      cIndex: index,
    });
    // await handleSuggestEstimate();
    setEditServiceModalOpen(true);
  };

  const RechargeEdit = async (cItem, index) => {
    setEditRechargeData({
      ...cItem,
      amount: CurrencyConverter.toCurrency(cItem.saleprice, "INR"),
      operator: cItem.operator,
      number: cItem.number,
      wallet: cItem.wallet,
      note: cItem.description,
      walletId: cItem.walletid,
      cIndex: index,
    });
    setEditRechargeModelOpen(true);
  };

  const salepriceEdit = async (cItem, index) => {
    const activeCart = carts.find((cart) => cart.isActive);

    if (!activeCart) return;

    let stockData = null;

    setEditSalePriceData({
      ...cItem,
      mrp: cItem.mrp,
      saleprice: cItem.saleprice,
      taxpercentage: cItem.taxpercentage,
      cIndex: index,

      stockMode: activeCart.stockMode,
      stockData,
    });

    setEditSalePriceModelOpen(true);
  };

  const handleEditServiceClose = () => {
    if (viewOption("saleSettings", "isScanBarcode")) {
      barcodeRef.current?.focus();
    } else {
      suggestionsRef.current?.focus();
    }
    setEditServiceModalOpen(false);
  };

  const handleFocusFill = (mode) => {
    const grandTotal = Number(
      CurrencyConverter.toCurrency(totalSoldRes.grandtotal || 0, "INR"),
    );

    setPaymentData((prev) => {
      const cash = Number(prev.cash || 0);
      const card = Number(prev.card || 0);
      const online = Number(prev.online || 0);
      const upi = Number(prev.upi || 0);
      const paylater = Number(prev.paylater || 0);

      const totalPaid = cash + card + online + upi + paylater;
      const remaining = grandTotal - totalPaid;

      if (remaining <= 0) return prev;

      const updated = {
        ...prev,
        cash: prev.cash || 0,
        card: prev.card || 0,
        online: prev.online || 0,
        upi: prev.upi || 0,
        paylater: prev.paylater || 0,
      };

      updated[mode] = Number(updated[mode]) + remaining;

      return updated;
    });

    const refs = {
      cash: cashRef,
      card: cardRef,
      online: onlineRef,
      upi: upiRef,
      paylater: paylaterRef,
    };

    setTimeout(() => {
      refs[mode]?.current?.select();
    }, 0);
  };

  const handleBarcodeKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();

      if (barcodeSearchTerm.trim() === "") {
        // Move to product search if barcode is empty
        suggestionsRef.current?.focus();
      } else {
        // Perform barcode search
        handleBarcodeSearch(barcodeSearchTerm);
      }
    }
  };

  const handleProductKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex((prev) =>
        Math.min(prev + 1, productSuggestions.length - 1),
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex((prev) => Math.max(prev - 1, 0));
    } else if (e.key === "Enter") {
      e.preventDefault();

      if (productSearchTerm.trim() === "") {
        customerSuggestionsRef.current?.focus();
        return;
      }

      if (highlightedIndex >= 0) {
        const selected = productSuggestions[highlightedIndex];
        handleSelectProduct(selected);
        setShowProductDropdown(false);
        setProductSearchTerm("");
        setHighlightedIndex(-1);
      }
    }
  };

  const handleCustomerKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex((prev) =>
        Math.min(prev + 1, customerSuggestions.length - 1),
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex((prev) => Math.max(prev - 1, 0));
    } else if (e.key === "Enter") {
      e.preventDefault();

      const trimmedSearch = customerSearchTerm.trim();

      if (trimmedSearch === "") {
        cashRef.current?.focus();
        return;
      }

      const noSelection = highlightedIndex === -1;
      const hasExactMatch = customerSuggestions.some((customer) => {
        const nameMatch =
          customer.name.toLowerCase() === trimmedSearch.toLowerCase();
        const phoneMatch = customer.phone === trimmedSearch;
        return nameMatch || phoneMatch;
      });

      if (noSelection && !hasExactMatch) {
        handleCustomerModalOpen();
        return;
      }

      if (highlightedIndex >= 0) {
        const selected = customerSuggestions[highlightedIndex];
        handleSelectCustomer(selected);
        customerSuggestionsRef.current?.focus();
        setShowCustomerDropdown(false);
        setCustomerSearchTerm("");
        setHighlightedIndex(-1);
      }
    }
  };

  const handleEnterFocus = (
    e,
    nextRef,
    mode,
    currentValue,
    nextMode,
    nextValue,
  ) => {
    if (e.key === "Enter") {
      e.preventDefault();

      const numericValue = Number(currentValue || 0);
      const nextNumericValue = Number(nextValue || 0);

      // ✅ Prefill *next* input if it's empty (not current)
      if (nextMode && !nextNumericValue) {
        handleFocusFill(nextMode);
      }

      // Move to next input
      nextRef?.current?.focus();
    }
  };

  const handlePaymodeKeyDown = (e, mode, currentValue) => {
    if (e.key === "Enter") {
      e.preventDefault();
      const numericValue = Number(currentValue || 0);
      if (!numericValue) {
        handleFocusFill(mode);
      }
      handleAdd(e);
    }
  };

  useEffect(() => {
    if (highlightedIndex >= 0 && suggestionRefs.current[highlightedIndex]) {
      suggestionRefs.current[highlightedIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [highlightedIndex]);

  useEffect(() => {
    if (!isActive) return;

    const timer = setTimeout(() => {
      if (viewOption("saleSettings", "isScanBarcode")) {
        barcodeRef.current?.focus();
      } else {
        suggestionsRef.current?.focus();
      }
    }, 0);

    return () => clearTimeout(timer);
  }, [isActive]);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    handleSuggestEstimate();
    if (hasModulePermission("SERVICE") || permission === undefined) {
      handleSuggestService();
    }
    handleBrandSuggest();
    handleSuggestNote();
    fetchFavouriteProducts();
  }, []);

  const addNewServiceName = (name) => {
    const trimmed = name?.trim();

    if (!trimmed) return; // ignore empty/whitespace input

    const exists = serviceNameSuggest?.some(
      (s) => s.serviceByName?.toLowerCase() === trimmed?.toLowerCase(),
    );

    if (!exists) {
      setServiceNameSuggest((prev) => [
        { _id: Date.now().toString(), serviceByName: trimmed },
        ...prev,
      ]);
    }
  };

  const addNewCustomNumber = (phone) => {
    const trimmed = phone?.trim();

    if (!trimmed) return; // ignore empty/whitespace input

    const exists = numberSuggest?.some(
      (s) => s.phone?.toLowerCase() === trimmed?.toLowerCase(),
    );

    if (!exists) {
      setNumberSuggest((prev) => [
        { _id: Date.now().toString(), phone: trimmed },
        ...prev,
      ]);
    }
  };
  const handleNewGroupClose = () => {
    setNewGroupOpen(false);
  };

  const handleListFavouriteProductOpen = () => {
    setFavouriteProductModel(true);
  };

  const handleListFavouriteProductClose = () => {
    if (viewOption("saleSettings", "isScanBarcode")) {
      barcodeRef.current?.focus();
    } else {
      suggestionsRef.current?.focus();
    }
    setFavouriteProductModel(false);
  };

  const handleNewGroupOpen = () => {
    setNewGroupOpen(true);
  };
  const handleCustomerGroupAdd = async (groupName, method) => {
    setAddGroupLoad(true);
    try {
      const data = {
        name: groupName,
      };
      const response = await AxiosInstance.post("module/customer/group", data);
      const results = response.data.results;
      //  setGroupName(results);
      setGroupName((prev) => [
        { ...results },
        ...(Array.isArray(prev) ? prev : []),
      ]);
      updateSettings({
        customerGroups: [
          { ...results },
          ...(Array.isArray(customerGroups) ? customerGroups : []),
        ],
      });

      showAlert("success", "Customer Group Added Successfull");
      setAddGroupLoad(false);
      handleNewGroupClose();
      setNewGroupName(results);
      if (method === "ADD") {
        handleCustomerModalOpen();
      } else {
        openEditModal(isEditData);
      }
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setAddGroupLoad(false);
    }
  };

  // const handleOfferToggle = (e) => {
  //   const checked = e.target.checked;
  //   setOfferEnabled(checked);

  //   if (!checked) {
  //     setSelectedOffer(null);
  //   }
  // };

  const handleOfferSelect = (value) => {
    if (!viewOption("saleSettings", "isOffer")) return;
    if (!offerEnabled) return;
    if (!value) return;

    const offer = Number(value);

    setSelectedOffer(offer);

    localStorage.setItem("selectedOffer", offer);

    const dropdown = document.querySelector(".dropdown-menu.show");
    if (dropdown) {
      dropdown.classList.remove("show");
    }
  };

  useEffect(() => {
    const savedOffer = localStorage.getItem("selectedOffer");
    const savedOfferEnabled = localStorage.getItem("offerEnabled");

    if (savedOffer) {
      setSelectedOffer(Number(savedOffer));
    }

    if (savedOfferEnabled !== null) {
      setOfferEnabled(savedOfferEnabled === "true");
    }
  }, []);

  useEffect(() => {
    const os = getOS();
    if (os === "macOS") {
      setShortcutKey("CMD + F");
    } else {
      setShortcutKey("Ctrl + F");
    }
  }, []);

  useEffect(() => {
    if (!viewOption("saleSettings", "isOffer")) {
      setOfferEnabled(false);
      setSelectedOffer(null);
    }
  }, [viewOption("saleSettings", "isOffer")]);

  useEffect(() => {
    if (!isActive) return; // Only enable shortcut when tab is active

    const handleKeyDown = (event) => {
      const isModifier = event.ctrlKey || event.metaKey;

      if (isModifier && event.key.toLowerCase() === "f") {
        event.preventDefault();
        setFavouriteProductModel(true);
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isActive]);

  useEffect(() => {
    setCash(paymentData.cash || 0);
    setCard(paymentData.card || 0);
    setOnline(paymentData.online || 0);
    setUpi(paymentData.upi || 0);
    setPaylater(paymentData.paylater || 0);
    setTotalPaid(paymentData.totalPaid || 0);
    setBalance(paymentData.balance || 0);
  }, [paymentData]);

  useEffect(() => {
    const handleArrowAndEnter = (e) => {
      // Only handle when search term is empty or suggestions list is empty
      if (!(productSearchTerm?.trim() === "")) return;
      if (!(productSuggestions?.length === 0)) return;
      if (!(customerSearchTerm?.trim() === "")) return;
      if (!(customerSuggestions?.length === 0)) return;
      if (!(favouriteRefs?.length === 0)) return;

      if (
        noteModalOpen ||
        isEditSalePriceModelOpen ||
        isEditStockPriceData ||
        isEditRechargeModelOpen ||
        isRecharageModalOpen ||
        isEditServiceModalOpen ||
        isServiceModalOpen ||
        isProductModalOpen ||
        isEditModalOpen ||
        isCustomerModalOpen ||
        isModeModalOpen ||
        isChangeModalOpen ||
        isSaleModalOpen ||
        isSoldPirceModalOpen ||
        isQuantityModalOpen ||
        isStockModalOpen ||
        globelPopupOpen
      )
        return;

      if (!["ArrowDown", "ArrowUp", "Enter"].includes(e.key)) return;

      e.preventDefault();

      const tableRows = Array.from(document.querySelectorAll("table tbody tr"));
      if (!tableRows.length) return;

      const currentRow = document.activeElement.closest("tr");
      let currentIndex = tableRows.indexOf(currentRow);

      // Handle Enter key
      if (e.key === "Enter") {
        if (currentIndex >= 0) {
          const item = tableRows[currentIndex].dataset.item
            ? JSON.parse(tableRows[currentIndex].dataset.item)
            : null;

          if (item) {
            if (item.imode === "SERVICE") {
              editItem(item, currentIndex);
            } else if (item.imode === "RECHARGE") {
              RechargeEdit(item, currentIndex);
            } else if (item.imode === "PRODUCT") {
              salepriceEdit(item, currentIndex);
            }
          }
        }
        return;
      }

      // Virtual -1: no row focused yet
      if (currentIndex === -1) {
        if (e.key === "ArrowDown") {
          tableRows[0].tabIndex = 0;
          tableRows[0].focus();
        } else if (e.key === "ArrowUp") {
          tableRows[tableRows.length - 1].tabIndex = 0;
          tableRows[tableRows.length - 1].focus();
        }
        return;
      }

      // Remove tabIndex from current row
      currentRow.tabIndex = -1;

      // Calculate next/previous index
      let nextIndex =
        e.key === "ArrowDown"
          ? (currentIndex + 1) % tableRows.length
          : (currentIndex - 1 + tableRows.length) % tableRows.length;

      const nextRow = tableRows[nextIndex];
      nextRow.tabIndex = 0;
      nextRow.focus();
    };

    window.addEventListener("keydown", handleArrowAndEnter);
    return () => window.removeEventListener("keydown", handleArrowAndEnter);
  }, [
    favouriteRefs,
    productSearchTerm,
    productSuggestions,
    noteModalOpen,
    isEditSalePriceModelOpen,
    isEditStockPriceData,
    isEditRechargeModelOpen,
    isRecharageModalOpen,
    isEditServiceModalOpen,
    isServiceModalOpen,
    isProductModalOpen,
    isEditModalOpen,
    isCustomerModalOpen,
    isModeModalOpen,
    isChangeModalOpen,
    isSaleModalOpen,
    isSoldPirceModalOpen,
    isQuantityModalOpen,
    isStockModalOpen,
    customerSuggestions,
    customerSearchTerm,
    globelPopupOpen,
  ]);

  useEffect(() => {
    // handleCustomerNumbersuggestion();

    const id = storeSettings?.invoiceSettings?.template?.templateId || "";
    const words = id ? id?.split("AND") : [];
    setSelectedOption(words[0]);
    setSelectTermalOption(words[1]);
  }, []);

  useEffect(() => {
    if (balance >= 0 && isChangeModalOpen) {
      setChangeModalOpen(false);
      setChangeData({});
    }
  }, [balance]);

  const activeCarts = carts.find((cart) => cart.isActive);
  useEffect(() => {
    if (!overallDiscountApplied) return;
     // Don't reset discount during Pre-Sale conversion
  if (isConvertingPreSale.current) {
    isConvertingPreSale.current = false;
    return;
  }
    if (isSwitchingCart.current) {
      isSwitchingCart.current = false;
      return;
    }

    if (skipNextGrandTotalChange.current) {
      skipNextGrandTotalChange.current = false;
      return;
    }

    resetOverallDiscount();
  }, [activeCarts?.items]);
  // console.log("totalSoldRes", totalSoldRes);

  // const handleGroupChange = (group) => {
  //   setSelectedGroupDetails(group);
  //   if (group && group._id) {
  //     handleGroupCustomerList(group);
  //   } else {
  //     setSelectedGroupId(null);
  //     setSelectedGroupDetails("");
  //   }
  // };

  const saveRemark = () => {
    const value = remarkInput.trim();

    setRemark(value);

    updateActiveCart((cart) => ({
      ...cart,
      Remark: value,
    }));
  };

  // console.log("activeCarts", activeCarts);
  // console.log("carts", carts);
  // console.log("Cart projectId:", activeCarts.projectId);
  const maxDiscount = CurrencyConverter.toCurrency(
    totalSoldRes.totalsaleprice || 0,
    "INR",
  );
  const isDiscountInvalid = Number(overallDiscount || 0) > maxDiscount;

  const handleConvertPreSale = async () => {
    setInsufficientStockItems("")
    try {
      if (!checkNetwork()) return;

      if (!preSaleId) {
        showAlert("warning", "Pre-Sale ID is missing");
        return;
      }

      setPreLoading(true);

      const response = await AxiosInstance.get(
        `module/presale/view/${preSaleId}`
      );
      if (response?.data?.status) {
        const presale = response?.data?.results;
        const preSaleData = presale?.preSaleData;

        const preSaleItems = preSaleData?.preSaleItems || [];
        const customer = preSaleData?.preSaleTo || null;
        const project = preSaleData?.projectId || "";
        const remarks = preSaleData?.remarks || "";
        const discount =
            CurrencyConverter.toCurrency(
              preSaleData?.overallDiscount?.overallDiscountAmount ?? 0,
              "INR"
            );

        const discountApplied =
          preSaleData?.overallDiscount?.overallDiscountAmount != null;
        // originalItemsRef.current = structuredClone(preSaleItems);

        // originalOverallDiscountRef.current = {
        //   overallDiscountAmount:
        //     preSaleData?.overallDiscount?.overallDiscountAmount ?? 0,

        //   previousItemDetails: preSaleItems.map((item) => ({
        //     soldprice: item.soldprice,
        //     quantity: item.quantity,
        //     lineTotalSoldPrice: item.lineTotalSoldPrice,
        //   })),
        // };

const previousItemDetails =
  preSaleData?.overallDiscount?.previousItemDetails || [];

const restoredPreSaleItems = preSaleItems.map((item, index) => {
  const previousItem = previousItemDetails[index];

  return {
    ...item,

    // ORIGINAL values BEFORE overall discount
    soldprice: previousItem?.soldPrice ?? item.soldprice,
    quantity: previousItem?.quantity ?? item.quantity,
    lineTotalSoldPrice:
      previousItem?.lineTotalSoldPrice ?? item.lineTotalSoldPrice,
  };
});

// This is the ORIGINAL / PRE-DISCOUNT cart.
// Used later when X is clicked.
originalItemsRef.current = structuredClone(restoredPreSaleItems);

// Tell cart effects this update came from Pre-Sale conversion
isConvertingPreSale.current = true;

setCarts((prevCarts) =>
  prevCarts.map((cart) => {
    if (!cart.isActive) {
      return cart;
    }

    return {
      ...cart,  
      items: structuredClone(preSaleItems),
      customer: customer,
      projectId: project,
      Remark: remarks,
      overallDiscount: discount,
      overallDiscountApplied: discountApplied,
    };
  }),
);


        setSelectedCustomer({
          customerData: customer,
        });
        // Update UI states
    
        setProjectId(project);
        setRemark(remarks);
        setRemarkInput(remarks);
        setOverallDiscount(discount);
        setOverallDiscountApplied(discountApplied);

        // Reset payment values
        setCash(0);
        setCard(0);
        setOnline(0);
        setUpi(0);
        setDiscount(0);
        setPaylater(0);
        setTotalPaid(0);
        setBalance(0);
        setChangeData({});
      }
      
    } catch (error) {
      console.error("Failed to convert pre-sale:", error);
    } finally {
      setPreLoading(false);
    }
  };

  useEffect(() => {
    
    if (!convertToSale || !preSaleId) {
      return;
    }

    // if (previousPreSaleIdRef.current === preSaleId) {
    //   return;
    // }
    previousPreSaleIdRef.current = preSaleId;    
    handleConvertPreSale();
    handleClose();
  }, [convertToSale, preSaleId]);

  useEffect(() => {
    setInsufficientStockItems((prev) => {
      if (!Array.isArray(prev)) return [];

      return prev.filter((stockItem) =>
        activeCarts?.items?.some(
          (cartItem) => cartItem._id === stockItem.productid
        )
      );
    });
  }, [activeCarts?.items]);

  const handleQuantityChanged = (productId, quantity) => {
    setInsufficientStockItems((prev) => {
      if (!Array.isArray(prev)) return [];

      return prev.filter((stockItem) => {
        if (stockItem.productid !== productId) {
          return true;
        }

        // Available stock according to API
        const availableQuantity = Number(stockItem.consumedQuantity || 0);

        // Keep error if still exceeding stock
        return Number(quantity) > availableQuantity;
      });
    });
  };
  
  return (
    <>
      <div>
        <div className="page-wrapper">
          <div className="page-content">
            <div className="row py-0">
              <div className="col-lg-9">
                <div className="card">
                  <div className="card-header px-3 py-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
                    <div className="flex-grow-1">
                      <div className="d-flex gap-2 flex-wrap">
                        <div className="dropdown">
                          <button
                            className="btn btn-primary position-relative"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <CartIcon />
                            <span className="ms-1">
                              {carts.findIndex((cart) => cart.isActive) + 1 ||
                                "1"}
                            </span>

                            {/* Badge on top-right corner */}
                            {/* {carts.find((cart) => cart.isActive)?.items
                              ?.length > 0 && (
                              <span
                                className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                                style={{ fontSize: "0.65rem" }}
                              >
                                {
                                  carts.find((cart) => cart.isActive).items
                                    .length
                                }
                              </span>
                            )} */}
                          </button>

                          <ul className="dropdown-menu">
                            {carts.map((cart, index) => (
                              <li key={index} onClick={() => switchCart(index)}>
                                <span
                                  className={`icon-text dropdown-item ${
                                    cart.isActive
                                      ? "bg-light-success text-success hover:bg-light-success"
                                      : "hover:bg-light"
                                  }`}
                                >
                                  <CartIcon iClass={"me-1"} />{" "}
                                  {/* small cart icon */}
                                  {cart.name}{" "}
                                  {cart.items?.length > 0 && (
                                    <span
                                      className={
                                        cart.isActive
                                          ? "text-success"
                                          : "text-muted"
                                      }
                                    >
                                      (<strong>{cart.items.length}</strong>{" "}
                                      {cart.items.length === 1
                                        ? "item"
                                        : "items"}
                                      )
                                    </span>
                                  )}
                                </span>
                              </li>
                            ))}
                          </ul>
                        </div>

                        <div className="input-group w-200">
                          <button className="input-group-text">
                            <CalendarIcon />
                          </button>
                          <input
                            type="text"
                            className="form-control createdon"
                            value={currentDate}
                            readOnly
                            disabled
                          />
                        </div>
                        <div
                          className="position-relative d-inline-block"
                          ref={dropdownRef}
                        >
                          <button
                            className="btn shadow-none bg-label-primary"
                            onClick={handleRecentSales}
                            type="button"
                          >
                            <RecentIcon /> recent sales
                          </button>

                          {showDropdown && (
                            <ul
                              className="dropdown-menu show p-2"
                              style={{
                                minWidth: "300px",
                                zIndex: 111050,
                                maxHeight: "300px",
                                overflowY: "auto",
                              }}
                            >
                              {lastSale?.length > 0 ? (
                                lastSale?.map((sale, saleIndex) => {
                                  return (
                                    <li
                                      key={sale?._id || saleIndex}
                                      onClick={() => handleRecentView(sale)}
                                      className="dropdown-item"
                                      style={{ cursor: "pointer" }}
                                    >
                                      <div className="fw-semibold text-dark">
                                        {sale?.saleno}
                                      </div>
                                      <div className="d-flex justify-content-between">
                                        <small className="text-muted">
                                          Items: {sale?.totalItems || 0}
                                        </small>
                                        <small className="text-muted">
                                          Time:{" "}
                                          {
                                            DateConverter.ISOToDisplayFormat(
                                              DateConverter.convertToTimeZone(
                                                sale?.createdAt,
                                                "Asia/Kolkata",
                                              ),
                                            ).time
                                          }
                                        </small>
                                        <small className="badge bg-label-fall rounded-pill">
                                          ₹
                                          {CurrencyConverter.toCurrency(
                                            sale?.grandtotal || 0,
                                            "INR",
                                          )}
                                        </small>
                                      </div>
                                    </li>
                                  );
                                })
                              ) : (
                                <li className="dropdown-item text-muted">
                                  No recent sale
                                </li>
                              )}
                            </ul>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="flex-grow-1 d-none d-md-block" />
                    <div className="d-flex gap-2 flex-wrap justify-content-end">
                      <button
                        className="btn shadow-none bg-label-service"
                        onClick={() => handleProductOpen()}
                      >
                        <AddIcon /> Product
                      </button>
                      <button
                        className="btn shadow-none bg-label-service"
                        onClick={() => handleServiceOpen()}
                      >
                        <AddIcon /> Service
                      </button>
                      {activeStoreModules("RECHARGE") && (
                        <button
                          className="btn shadow-none bg-label-service"
                          onClick={() => handleRechargeOpen()}
                        >
                          <AddIcon /> Recharge
                        </button>
                      )}
                    </div>
                  </div>
                  <div className="card-body mt-3 py-0">
                    <div className="row g-2">
                      {viewOption("saleSettings", "isScanBarcode") && (
                        <div
                          className="col-sm-3"
                          style={{ position: "relative" }}
                        >
                          <div className="input-group">
                            <button className="input-group-text">
                              <BarcodeIcon />
                            </button>
                            <input
                              type="text"
                              className="form-control createdon"
                              name="barcodeSearch"
                              ref={barcodeRef}
                              value={barcodeSearchTerm}
                              onChange={(e) =>
                                setBarcodeSearchTerm(e.target.value)
                              }
                              onKeyDown={handleBarcodeKeyDown}
                              placeholder="Scan Barcode"
                              autoFocus
                            />
                          </div>
                        </div>
                      )}
                      <div
                        className="col-sm-4"
                        style={{ position: "relative" }}
                      >
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            name="search"
                            ref={suggestionsRef}
                            autoComplete="off"
                            value={productSearchTerm}
                            onChange={(e) => {
                              const value = e.target.value;

                              // ✅ FIX 4: detect delete
                              if (value.length < productSearchTerm.length) {
                                setHighlightedIndex(0);
                              }

                              setProductSearchTerm(value);

                              setProductSuggestions([]); // (from Fix 1 - important)
                              setShowProductDropdown(true);

                              handleProductSearch(value);
                            }}
                            onKeyDown={handleProductKeyDown}
                            onFocus={() => {
                              if (productSuggestions.length > 0) {
                                setShowProductDropdown(true);
                              }
                            }}
                            placeholder="Search products ..."
                            autoFocus
                          />
                          <button className="input-group-text">
                            <SearchIcon />
                          </button>
                        </div>
                        {productSearchTerm &&
                          productSuggestions.length === 0 && (
                            <ul className="suggestions-list">
                              <li className="suggestion-item text-muted">
                                No products data was found
                              </li>
                            </ul>
                          )}
                        {showProductDropdown &&
                          productSuggestions.length > 0 && (
                            <ProductSearchList
                              suggest={productSuggestions}
                              suggestionRefs={suggestionRefs}
                              handleSelect={handleSelectProduct}
                              activeIndex={highlightedIndex}
                            />
                          )}
                      </div>

                      <div className="col d-flex justify-content-end gap-2">
                        {insufficientStockItems.length > 0 && (
                          <div className="p-2 text-center"
                            style={{
                              color: "#d32f2f",
                              backgroundColor: "#ffebee",
                              
                              borderRadius: "6px",
                              fontWeight: 500,
                            }}
                          > Insufficient stock:<span className="ms-1 fw-bold">
                            {insufficientStockItems.length}{" "}
                            {insufficientStockItems.length === 1 ? "item" : "items"} </span>
                          
                          </div>
                        )}
                        {/* Offer Dropdown */}
                        {viewOption("saleSettings", "isOffer") && (
                          <Tooltip title="Sale Price Offer" arrow>
                            <div className="btn-group">
                              {/* LEFT BUTTON (Enable / Disable Offer) */}
                              <button
                                type="button"
                                className={`btn border-0 ${
                                  offerEnabled
                                    ? "btn-warning text-dark"
                                    : "btn-offer-disabled"
                                }`}
                                onClick={() => {
                                  const newValue = !offerEnabled;
                                  setOfferEnabled(newValue);

                                  localStorage.setItem(
                                    "offerEnabled",
                                    newValue,
                                  );
                                }}
                              >
                                <OfferIcon />{" "}
                                {selectedOffer ? `${selectedOffer}%` : ""}
                              </button>

                              {/* RIGHT DROPDOWN BUTTON */}
                              <button
                                type="button"
                                className={`btn dropdown-toggle dropdown-toggle-split ${
                                  offerEnabled
                                    ? "btn-warning text-dark"
                                    : "btn-offer-disabled"
                                }`}
                                data-bs-toggle="dropdown"
                                onClick={() => {
                                  if (!offerEnabled) {
                                    setOfferEnabled(true);
                                    localStorage.setItem("offerEnabled", true);
                                  }
                                }}
                              >
                                {/* <span className="visually-hidden">
                                Toggle Dropdown
                              </span> */}
                              </button>

                              {/* DROPDOWN MENU */}
                              <ul className="dropdown-menu">
                                <li>
                                  <button
                                    className="dropdown-item"
                                    onClick={() => handleOfferSelect(10)}
                                  >
                                    10%
                                  </button>
                                </li>

                                <li>
                                  <button
                                    className="dropdown-item"
                                    onClick={() => handleOfferSelect(20)}
                                  >
                                    20%
                                  </button>
                                </li>

                                <li>
                                  <button
                                    className="dropdown-item"
                                    onClick={() => handleOfferSelect(35)}
                                  >
                                    35%
                                  </button>
                                </li>

                                <li>
                                  <button
                                    className="dropdown-item"
                                    onClick={() => handleOfferSelect(50)}
                                  >
                                    50%
                                  </button>
                                </li>

                                <li>
                                  <hr className="dropdown-divider" />
                                </li>

                                <li className="px-3 py-2">
                                  <input
                                    step="0.01"
                                    max="99.99"
                                    min="0"
                                    placeholder="Custom %"
                                    className="form-control form-control-sm"
                                    onBlur={(e) => {
                                      const value = e.target.value;
                                      if (!value) return;

                                      const formatted = Number(
                                        parseFloat(value).toFixed(2),
                                      );
                                      handleOfferSelect(formatted);
                                    }}
                                  />
                                </li>
                              </ul>
                            </div>
                          </Tooltip>
                        )}

                        {/* Favourite Button */}
                        {uRLs.FAVOURITE_SALE === "true" && (
                          <Tooltip title={shortcutKey} arrow>
                            <span>
                              <button
                                className="btn shadow-none btn-label-primary"
                                onClick={() => handleListFavouriteProductOpen()}
                              >
                                <StarIcon iClass={"text-warning"} /> Favourites
                              </button>
                            </span>
                          </Tooltip>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="card-body px-0">
                    <div
                      className="table-responsive mt-0"
                      style={{
                        maxHeight: "500px",
                        overflowY: "auto",
                        msOverflowStyle: "none",
                        scrollbarWidth: "thin",
                        overflowX: "hidden",
                      }}
                    >
                      <table className="table table-bordered align-middle mb-0">
                        <thead
                          className="table-light"
                          style={{
                            position: "sticky",
                            top: 0,
                            zIndex: 8,
                          }}
                        >
                          <tr>
                            <th className="text-center">S.No</th>
                            <th className="w-30">Description</th>
                            <th className="text-center">MRP</th>
                            <th className="text-center">Discount</th>
                            <th className="text-center">Sale Price</th>
                            <th className="text-center">Qty</th>
                            <th className="text-center">Total</th>
                            <th className="text-center">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                        {activeCarts?.items?.map((item, index) => {
    const isInsufficientStock = Array.isArray(insufficientStockItems) &&
      insufficientStockItems.some(
        (stockItem) => stockItem.productid === item._id
      );

    return (
                            <tr
                              key={item.imode + index}
                                className={`position-relative cursor-poInter hover-row ${
          isInsufficientStock ? "insufficient-stock-row" : ""
        }`}
                              // className="position-relative  cursor-poInter hover-row"
                              onClick={() => {
                                if (item.imode === "SERVICE") {
                                  editItem(item, index);
                                } else if (item.imode === "RECHARGE") {
                                  RechargeEdit(item, index);
                                } else if (item.imode === "PRODUCT") {
                                  salepriceEdit(item, index);
                                }
                              }}
                              data-item={JSON.stringify(item)}
                            >
                              <td className="text-center">
                                {index + 1}
                                {item.imode === "SERVICE" && (
                                  <span className="rounded fsz-10 ms-1">
                                    <CircleIcon iClass={"text-yellow"} />
                                  </span>
                                )}
                                {item.imode === "RECHARGE" && (
                                  <span className="rounded fsz-10 ms-1">
                                    <CircleIcon iClass={"text-yellow"} />
                                  </span>
                                )}
                                {item.imode === "PRODUCT" && (
                                  <span className="rounded fsz-10 ms-1">
                                    <CircleIcon iClass={"text-primary"} />
                                  </span>
                                )}
                              </td>
                              <td className="text-wrap" width="280">
                                <div className="d-flex justify-content-between align-items-start">
                                  <div className="me-2">
                                    {item.title} - &nbsp;
                                    <small className="badge rounded-pill bg-label-peace">
                                      {item.taxpercentage}%
                                    </small>
                                    {item.imode === "SERVICE" && (
                                      <div className="ms-0 fs-12 text-truncate-description">
                                        {item.description}
                                      </div>
                                    )}
                                    {item.imode === "PRODUCT" && (
                                      <div className="ms-0 fs-12 text-truncate-description text-muted d-flex align-items-start">
                                        <button
                                          type="button"
                                          className="me-2 rounded btn-label-primary shadow-none border-0"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleProductNote(item);
                                          }}
                                        >
                                          <NotepadIcon />
                                        </button>
                                        {item.note && <span>{item.note}</span>}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </td>
                              <td className="text-center">
                                ₹
                                {CurrencyConverter.toCurrency(
                                  item.mrp || 0,
                                  "INR",
                                )}
                              </td>
                              <td className="text-center">
                                ₹
                                {CurrencyConverter.toCurrency(
                                  item.discount || 0,
                                  "INR",
                                )}
                              </td>
                              <td className="text-center">
                                ₹
                                {CurrencyConverter.toCurrency(
                                  item.soldprice || 0,
                                  "INR",
                                )}
                              </td>
                              <td className="w-120">
                                {item.imode === "SERVICE" ||
                                item.imode === "RECHARGE" ? (
                                  <span className="text-center d-block">
                                    {item.quantity}{" "}
                                    {item?.unitConfig?.primaryUnitCode}{" "}
                                    {/* {item.unit && <small>/ {item.unit}</small>} */}
                                  </span>
                                ) : (
                                  // <div className="input-group">
                                  //   <input
                                  //     type="text"
                                  //     value={item.quantity}
                                  //     onFocus={(e) => {
                                  //       e.stopPropagation();
                                  //       handleQuantity(item, index);
                                  //     }}
                                  //     className="form-control text-center w-140"
                                  //     min="1"
                                  //   />

                                  //   {item?.unit && (
                                  //     <span
                                  //       className="input-group-text text-muted"
                                  //       style={{
                                  //         fontSize: "11px",
                                  //         padding: "0 6px",
                                  //       }}
                                  //     >
                                  //       {item?.unit || "Units"}
                                  //     </span>
                                  //   )}
                                  // </div>

                                  <div className="text-center">
                                    {item.quantity} {item?.unit}{" "}
                                  </div>
                                )}
                              </td>
                              <td className="text-center">
                                ₹
                                {CurrencyConverter.toCurrency(
                                  item.lineGrandTotal || 0,
                                  "INR",
                                )}
                              </td>
                              <td className="text-center">
                                <div className="order-actions ">
                                  {item.imode === "SERVICE" && (
                                    <>
                                      <button
                                        className="btn-label-primary shadow-none me-2"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          editItem(item, index);
                                        }}
                                      >
                                        <EditIcon />
                                      </button>
                                    </>
                                  )}
                                  {item.imode === "RECHARGE" && (
                                    <>
                                      <button
                                        className="btn-label-primary shadow-none me-2"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          RechargeEdit(item, index);
                                        }}
                                      >
                                        <EditIcon />
                                      </button>
                                    </>
                                  )}
                                  {item.imode === "PRODUCT" && (
                                    <>
                                      <button
                                        className="btn-label-primary shadow-none me-2"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          salepriceEdit(item, index);
                                        }}
                                      >
                                        <EditIcon />
                                      </button>
                                    </>
                                  )}
                                  <button
                                    className="btn-label-danger shadow-none"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      removeItem(index);
                                    }}
                                  >
                                    <DeleteIcon />
                                  </button>
                                </div>
                              </td>
                            </tr>
        );
  })}
                        </tbody>
                      </table>
                    </div>
                    <div className="row bg-light border-0 mt-2 text-center align-items-center m-0">
                      <div className="col p-2">
                        <p className="mb-0">Total MRP</p>
                        <h6 className="mb-0 fs-20">
                          {CurrencyConverter.toCurrency(
                            totalSoldRes.totalmrp || 0,
                            "INR",
                          )}
                        </h6>
                      </div>
                      <div className="col p-2 fs-20">
                        <MinusIcon iClass={"text-muted"} />
                      </div>
                      <div className="col p-2">
                        <p className="mb-0">Total Discount</p>
                        <h6 className="mb-0 fs-20">
                          {CurrencyConverter.toCurrency(
                            totalSoldRes.totaldiscount || 0,
                            "INR",
                          )}
                        </h6>
                      </div>
                      <div className="col p-2 fs-20">
                        <LineDoubleIcon iClass={"text-muted"} />
                      </div>
                      <div className="col bg-dark-shine p-1 radius-10">
                        <p className="mb-0 bg-dark-shine">Total Amount</p>
                        <h6 className="mb-0 bg-dark-shine fs-20">
                          {CurrencyConverter.toCurrency(
                            totalSoldRes.totalsaleprice || 0,
                            "INR",
                          )}
                        </h6>
                      </div>
                      <div className="col p-2 fs-20">
                        <LineDoubleIcon iClass={"text-muted"} />
                        <ChevronRightIcon iClass={"text-muted"} />
                      </div>
                      <div className="col bg-dark-blue p-1">
                        <p className="mb-0 bg-dark-text fw-600">Grand Total </p>
                        <small className="fs-12 mt-0"> (Rounded) </small>
                        <h6 className="mb-0 bg-dark-text fs-20 fw-600">
                          {CurrencyConverter.toCurrency(
                            totalSoldRes.grandtotal || 0,
                            "INR",
                          )}
                        </h6>
                      </div>
                    </div>
                    {/* <div
                      className="col-lg-2 mt-2 btn-label-dark mb-0 ms-2 p-1 rounded"
                      style={{ cursor: "pointer" }}
                      onClick={() => setRemarkModalOpen(true)}
                    > */}
                    {/* Top Row */}
                    {/* {viewOption("saleSettings", "isRemark") && (
                      <div className="mt-2 ms-2 mb-0">
                        <button
                          type="button"
                          className="btn-label-secondary rounded shadow-none border-0 me-2 px-2 py-1"
                          onClick={() => setRemarkModalOpen(true)}
                        >
                          <div className="d-flex flex-column align-items-start">
                            <span>
                              <i className="ng ng-ng-edit-icon me-2"></i>
                              Remark
                            </span>

                            {remark && (
                              <small
                                className="text-muted text-truncate d-block"
                                style={{ maxWidth: "120px" }}
                              >
                                {remark.split("\n")[0]}
                              </small>
                            )}
                          </div>
                        </button>
                      </div>
                    )} */}
                    {/* Bottom Row (Preview) */}
                    {/* {remark && (
                        <div className="remark-preview mt-1">
                          {remark.split("\n")[0]}
                        </div>
                      )} */}
                    {/* </div> */}
                  </div>
                </div>
              </div>

              <div className="col-lg-3">
                <div className="card">
                  <div className="card-body">
                    {!selectedCustomer && (
                      <div className="ms-auto position-relative">
                        <SearchInput
                          searchRef={customerSuggestionsRef}
                          value={customerSearchTerm}
                          onChange={(e) => {
                            handleCustomerSearch(e.target.value);
                            setShowCustomerDropdown(true);
                            setHighlightedIndex(-1);
                          }}
                          onFocus={() => {
                            if (customerSuggestions.length > 0) {
                              setShowCustomerDropdown(true);
                            }
                          }}
                          onSearch={
                            customerSearchTerm.trim()
                              ? () =>
                                  handleCustomerModalOpen(
                                    customerSearchTerm.trim(),
                                  )
                              : null
                          }
                          onKeyPress={handleKeyPress}
                          placeholder="Search customer by name, phone, email, referenceID..."
                          onKeyDown={handleCustomerKeyDown}
                        />
                        {customerSearchTerm &&
                          customerSuggestions.length === 0 && (
                            <ul className="suggestions-list">
                              <li className="suggestion-item text-muted">
                                No customers data was found
                              </li>
                            </ul>
                          )}
                        {showCustomerDropdown &&
                          customerSuggestions.length > 0 && (
                            <ProductSearchList
                              suggest={customerSuggestions}
                              suggestionRefs={suggestionRefs}
                              handleSelect={handleSelectCustomer}
                              activeIndex={highlightedIndex}
                              type="customer"
                            />
                          )}
                      </div>
                    )}
                    <div className="col-lg-12 mt-1">
                      <div className="card shadow-none border-blue mb-0">
                        <div className="card-header bg-label-orange p-2 d-flex justify-content-between align-items-center">
                          <div className="mb-0">Customer Info</div>
                          {selectedCustomer?.customerData && (
                            <div className="d-flex gap-1">
                              <button
                                type="button"
                                className="btn-label-primary rounded shadow-none border-0 cursor-pointer"
                                onClick={() =>
                                  openEditModal(selectedCustomer?.customerData)
                                }
                              >
                                <EditIcon />
                              </button>

                              <button
                                type="button"
                                className="btn-label-danger rounded shadow-none border-0 cursor-pointer"
                                onClick={handleRemoveCustomer}
                              >
                                <RemoveIcon />
                              </button>
                            </div>
                          )}
                        </div>
                        <div className="card-body px-2 py-0">
                          {selectedCustomer ? (
                            <>
                              <p className="my-1 fs-13">
                                Name :{" "}
                                <span className="fw-600 fs-14">
                                  {selectedCustomer?.customerData?.name}
                                </span>
                              </p>
                              <p className="my-1 fs-13">
                                Phone :{" "}
                                <span className="fw-600 fs-14">
                                  {selectedCustomer?.customerData?.phone}{" "}
                                </span>
                              </p>
                              {selectedCustomer?.customerData?.gstnumber && (
                                <p className="my-1 fs-13">
                                  GST :{" "}
                                  <span className="fw-600 fs-14">
                                    {selectedCustomer?.customerData?.gstnumber}
                                  </span>
                                </p>
                              )}
                              {selectedCustomer?.customerData?.addressline1 && (
                                <p className="my-1 fs-13">
                                  Address :{" "}
                                  <span className="fw-600 fs-14">
                                    {selectedCustomer?.customerData?.addressline1}
                                  </span>
                                </p>
                              )}
                              {selectedCustomer?.customerData?.state && (
                                <p className="my-1 fs-13">
                                  State:{" "}
                                  <span className="fw-600 fs-14">
                                    {selectedCustomer?.customerData?.state}
                                  </span>
                                </p>
                              )}
                              {selectedCustomer?.customerData?.referenceid && (
                                <p className="my-1 fs-13">
                                  Reference ID :{" "}
                                  <span className="fw-600 fs-14">
                                    {selectedCustomer?.customerData?.referenceid}
                                  </span>
                                </p>
                              )}

                              {selectedCustomer?.paylaterData?._id && (
                                <p className="my-1 fs-13">
                                  Pay Later Balance :{" "}
                                  <span
                                    className={`fw-600 fs-14 ${
                                      selectedCustomer.paylaterData
                                        .closeamount < 0
                                        ? "badge bg-label-danger rounded-pill"
                                        : "badge bg-label-success text-success rounded-pill"
                                    }`}
                                  >
                                    {CurrencyConverter.toCurrency(
                                      selectedCustomer.paylaterData
                                        .closeamount || 0,
                                      "INR",
                                    )}
                                  </span>
                                </p>
                              )}
                            </>
                          ) : (
                            <p className="my-2 text-muted">
                              No customers has been selected
                            </p>
                          )}
                        </div>
                      </div>
                      {/* <CustomerInfo selectedCustomer={selectedCustomer?.customerData} onEditModel={openEditModal} paylater={selectedCustomer?.paylaterData}/> */}
                    </div>
                  </div>
                </div>
                {uRLs.PROJECT === "true" &&
                  activeStoreModules("PROJECT") &&
                  (hasModulePermission("PROJECT") ||
                    permission === undefined) && (
                    <div>
                      <ProjectSale
                        isActive={isActive}
                          selectedProjectId={
                            typeof activeCarts?.projectId === "object"
                              ? activeCarts?.projectId?._id
                              : activeCarts?.projectId
                          }
                        onSelectProject={handleProjectSelect}
                        resetProject={resetProject}
                      />
                    </div>
                  )}
                {viewOption("saleSettings", "isRemark") && (
                  <div className="card">
                    <div className="card-body">
                      <div
                        className="d-flex align-items-center mb-2"
                        style={{
                          color: "#16a34a",
                          // fontWeight: "600",
                          // fontSize: "13px",
                        }}
                      >
                        <NotepadIcon iClass={"me-1 font-16"} />
                        <h8 className="mb-0"> Remark</h8>
                        {remark?.trim() && (
                          <div className="ms-auto">
                            <button
                              type="button"
                              className="btn-label-primary rounded shadow-none border-0 cursor-pointer"
                              onClick={() => {
                                setRemark(activeCarts?.Remark || "");
                                setRemarkModalOpen(true);
                              }}
                            >
                              <EditIcon />
                            </button>
                          </div>
                        )}
                      </div>

                      {!remark?.trim() ? (
                        <textarea
                          className="form-control"
                          rows={3}
                          placeholder="Enter remark..."
                          value={remarkInput}
                          onChange={(e) => setRemarkInput(e.target.value)}
                          onBlur={saveRemark}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" && !e.shiftKey) {
                              e.preventDefault();
                              saveRemark();
                              e.target.blur(); // optional: removes focus after saving
                            }
                          }}
                        />
                      ) : (
                        <>
                          <div
                            style={{
                              color: "#4b5563",
                              fontSize: "12px",
                              lineHeight: "1.6",
                              wordBreak: "break-word",
                              ...(showFullRemark
                                ? {}
                                : {
                                    display: "-webkit-box",
                                    WebkitLineClamp: 3,
                                    WebkitBoxOrient: "vertical",
                                    overflow: "hidden",
                                  }),
                            }}
                          >
                            {capitalizeFirstLetter(remark)}
                          </div>

                          {remark.length > 120 && (
                            <span
                              onClick={() => setShowFullRemark(!showFullRemark)}
                              style={{
                                color: "#2563eb",
                                fontSize: "12px",
                                cursor: "pointer",
                                fontWeight: "500",
                              }}
                            >
                              {showFullRemark ? "Show Less" : "...more"}
                            </span>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                )}

                {viewOption("saleSettings", "isOverallDiscount") && (
                  <div className="card">
                    <div className="card-body">
                      <div className="d-flex justify-content-between">
                        <div className="d-flex align-items-center">
                          <h8 className="mb-0">Overall Discount :</h8>
                        </div>
                        <div style={{ width: "160px" }}>
                          <div className="position-relative">
                            <input
                              type="text"
                              disabled={overallDiscountApplied}
                              className="form-control text-center pe-4"
                              value={overallDiscount ||""}
                              onChange={(e) => {
                                const value = e.target.value;

                                if (value === "") {
                                  setOverallDiscount("");
                                  return;
                                }

                                if (!/^\d*\.?\d*$/.test(value)) return;

                                setOverallDiscount(value);
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();

                                  if (
                                    !isDiscountInvalid &&
                                    !overallDiscountApplied &&
                                    Number(overallDiscount) > 0
                                  ) {
                                    applyOverallDiscount();
                                  }
                                }
                              }}
                            />

                            {/* overallDiscount && */}
                              {Number(overallDiscount) > 0 &&
                              (overallDiscountApplied ? (
                                <button
                                  type="button"
                                  className="btn btn-sm btn-label-danger position-absolute top-50 end-0 translate-middle-y me-1 p-1 d-flex align-items-center justify-content-center  shadow-none"
                                  style={{ width: "26px", height: "26px" }}
                                  onClick={removeOverallDiscount}
                                >
                                  <XIcon iClass={"fs-5"} />
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  className={`btn btn-sm position-absolute top-50 end-0 translate-middle-y me-1 p-1 d-flex align-items-center justify-content-center  shadow-none ${
                                    isDiscountInvalid
                                      ? "btn-secondary disabled"
                                      : "btn-label-success"
                                  }`}
                                  style={{ width: "26px", height: "26px" }}
                                  onClick={() => {
                                    if (
                                      !isDiscountInvalid &&
                                      !overallDiscountApplied
                                    ) {
                                      applyOverallDiscount();
                                    }
                                  }}
                                >
                                  <CheckIcon iClass={"fs-5"} />
                                </button>
                              ))}
                          </div>

                          {isDiscountInvalid && (
                            <small className="text-danger d-block mt-1">
                              Discount cannot be greater than ₹
                              {CurrencyConverter.toCurrency(
                                totalSoldRes.grandtotal || 0,
                                "INR",
                              )}
                            </small>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="card mb-6">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center">
                      <p className="mb-0" style={{ fontSize: "13px" }}>
                        Total MRP :
                      </p>
                      <h6 className="mb-0 fs-20" style={{ fontSize: "14px" }}>
                        {formatCurrencyFun(totalSoldRes?.totalmrp)}
                      </h6>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <p className="mb-0" style={{ fontSize: "13px" }}>
                        Total Discount :
                      </p>
                      <h6 className="mb-0 fs-20" style={{ fontSize: "14px" }}>
                        {formatCurrencyFun(totalSoldRes?.totaldiscount)}
                      </h6>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <p className="mb-0" style={{ fontSize: "13px" }}>
                        Total Amount :
                      </p>
                      <h6 className="mb-0 fs-20" style={{ fontSize: "14px" }}>
                        {formatCurrencyFun(totalSoldRes?.totalsaleprice)}
                      </h6>
                    </div>
                    <div className="bg-light rounded p-2 text-center mb-3">
                      <h6 className="mb-0 fs-18 text-dark">
                        Total Payable :{" "}
                        <span>
                          {" "}
                          {formatCurrencyFun(totalSoldRes.grandtotal)}{" "}
                        </span>
                      </h6>
                    </div>

                    <div className="modal-footer d-block mt-3">
                      <button
                        type="button"
                        className="btn shadow-none btn-outline-secondary text-left"
                        onClick={handleCancel}
                      >
                        <XIcon /> Clear
                      </button>
                      {isbtnLoading ? (
                        <button
                          className="btn btn-primary pb-0 text-right"
                          disabled
                        >
                          <CircularProgress size={22} className="text-white" />
                        </button>
                      ) : (
                        <button
                          ref={buttonRef}
                          type="button"
                            className={`btn ${
                            hasInsufficientStock
                              ? "btn-secondary"
                              : "btn-primary"
                          } text-right w-48`}
                          onClick={handleProceed}
                           disabled={hasInsufficientStock}
                        >
                          <CheckIcon />
                          {mode === "PROFORMA"
                            ? " Create Proforma"
                            : " Proceed"}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <PaymentMethod
            open={paymentModal}
            paymentData={paymentData}
            setPaymentData={setPaymentData}
            totalPayable={totalPayable}
            onDone={() => handleAdd(paymentData)}
            onClose={handlePaymentClose}
            handleFocusFill={handleFocusFill}
            handleEnterFocus={handleEnterFocus}
          />

          <RemarkModal
            open={remarkModalOpen}
            initialValue={remark}
            onClose={() => setRemarkModalOpen(false)}
            onSave={(val) => {
              setRemark(val);
              setRemarkInput(val);

              updateActiveCart((cart) => ({
                ...cart,
                Remark: val,
              }));

              setRemarkModalOpen(false);
            }}
          />

          {isStockModalOpen && (
            <FindStock
              data={isStockData}
              recent={recentData}
              addToCart={addProductToCart}
              onClose={handleStockClose}
              offer={offerEnabled ? selectedOffer : null}
              customerSearchTerm={customerSearchTerm}
              customerSuggestions={customerSuggestions}
              highlightedIndex={highlightedIndex}
              showCustomerDropdown={showCustomerDropdown}
              selectedCustomer={selectedCustomer}
              suggestionRefs={suggestionRefs}
              customerSuggestionsRef={customerSuggestionsRef}
              handleCustomerSearch={handleCustomerSearch}
              handleSelectCustomer={handleSelectCustomer}
              handleCustomerKeyDown={handleCustomerKeyDown}
              handleKeyPress={handleKeyPress}
              setShowCustomerDropdown={setShowCustomerDropdown}
              noteSuggests={noteSuggest}
              brandSuggest={brandSuggest}
              setBrandSuggest={setBrandSuggest}
            />
          )}
          {isQuantityModalOpen && (
            <UpdateQty
              data={isQuantityData}
              ItemIndex={isQuantityIndex}
              updateQuantity={handleQuantityUpdate}
              onClose={handleQuantityClose}
            />
          )}
          {!templateId && isViewModalOpen && (
            <InvoiceTempPreview
              isData={data}
              onClose={() => setViewModalOpen(false)}
              onAdd={handleSetTemplate}
            />
          )}
          {templateId && isSaleModalOpen && (
            <TemplateModalLayout
              isOpen={isSaleModalOpen}
              isData={data}
              onClose={handleClose}
              selectedOption={selectedOption}
              setSelectedOption={setSelectedOption}
              setSaleData={setSaleData}
              isActive={isActive}
            />
          )}
          {isSoldPirceModalOpen && (
            <UpdatePrice
              data={isProductData}
              addToCart={addProductToCart}
              onClose={handleSoldPriceClose}              
              offer={offerEnabled ? selectedOffer : null}
              customerSearchTerm={customerSearchTerm}
              customerSuggestions={customerSuggestions}
              highlightedIndex={highlightedIndex}
              showCustomerDropdown={showCustomerDropdown}
              selectedCustomer={selectedCustomer}
              suggestionRefs={suggestionRefs}
              customerSuggestionsRef={customerSuggestionsRef}
              handleCustomerSearch={handleCustomerSearch}
              handleSelectCustomer={handleSelectCustomer}
              handleCustomerKeyDown={handleCustomerKeyDown}
              handleKeyPress={handleKeyPress}
              setShowCustomerDropdown={setShowCustomerDropdown}
              noteSuggests={noteSuggest}
              brandSuggest={brandSuggest}
              setBrandSuggest={setBrandSuggest}
              onStockChanged={handleStockChanged}
            />
          )}
          {isChangeModalOpen && (
            <ChangeModal
              changeAmount={balance}
              onClose={handleChangeModalClose}
              onConfirm={handleChangeConfirm}
            />
          )}
          {isModeModalOpen && (
            <ModeModal
              onClose={handleModeModalClose}
              onConfirm={handleAddSale}
            />
          )}

          {/* {isCustomerModalOpen && (
        <CustomerModal
          onClose={handleCustomerModalClose}
          onConfirm={handleCustomerAdd}
          onData={isCustomerData}
          isBtnLoading={isBtnLoading}
          groupName={groupName}
          onNewGroupsIn={handleCustomerGroupAdd}
          newGroup={newGroupName}
        />
      )}  */}

          <AddCustomer
            isActive={isActive}
            isOpen={isCustomerModalOpen}
            onClose={handleCustomerModalClose}
            onData={isCustomerData}
            onAdd={handleCustomerAdd}
            isBtnLoading={isBtnLoading}
            groupName={groupName}
            onNewGroupsIn={handleCustomerGroupAdd}
            newGroup={newGroupName}
            resetAll={true}
            error={error}
            setErrors={setErrors}
            numberSuggest={numberSuggest}
            addNewCustomNumber={addNewCustomNumber}
          />
          {isEditModalOpen && (
            <EditCutomer
              isActive={isActive}
              editData={isEditData}
              onClose={closeEditModal}
              onEdit={handleUpdte}
              isBtnLoading={isBtnLoading}
              groupName={groupName}
              onNewGroupsIn={handleCustomerGroupAdd}
              resetAll={true}
              groupId={selectedCustomer?.customerData?.groupid}
              newGroup={newGroupName}
              error={error}
              setErrors={setErrors}
            />
          )}

          {isProductModalOpen && (
            <AddProductSearch
              // onAdd={() => addProduct()} // for footer button
              onClose={handleProductClose}
              isBtnLoading={isBtnLoading}
              productSearchTerm={productSearchTerm}
              setProductSearchTerm={setProductSearchTerm}
              handleProductSearch={handleProductSearch}
              productSuggestions={productSuggestions}
              handleSelectProduct={handleSelectProduct}
              handleProductKeyDown={handleProductKeyDown}
              showProductDropdown={showProductDropdown}
              setShowProductDropdown={setShowProductDropdown}
              highlightedIndex={highlightedIndex}
              setHighlightedIndex={setHighlightedIndex}
              catalogItems={categories}
            />
          )}

          {isServiceModalOpen && (
            <AddService
              isActive={isActive}
              onClose={handleServiceClose}
              onAdd={addServiceToCart}
              isBtnLoading={isBtnLoading}
              estimateSuggest={estimateSuggest}
              serviceNameSuggests={serviceNameSuggest}
              addNewServiceName={addNewServiceName}
              isServiceName={true}
              showQuanity={true}
            />
          )}

          {isEditServiceModalOpen && (
            <EditService
              isActive={isActive}
              onClose={handleEditServiceClose}
              onUpdate={addServiceToCart}
              editData={isServiceData}
              isBtnLoading={isBtnLoading}
              estimateSuggest={estimateSuggest}
              serviceNameSuggests={serviceNameSuggest}
              addNewServiceName={addNewServiceName}
              isServiceName={true}
              showQuanity={true}
            />
          )}

          {isRecharageModalOpen && (
            <AddRecharge
              onClose={handleRechargeClose}
              onAdd={addRechargeToCart}
              isBtnLoading={isBtnLoading}
              // rechargeSuggest={[]}
            />
          )}

          {isEditRechargeModelOpen && (
            <EditRecharge
              editData={isEditRechargeData}
              onClose={handleEditRechargeClose}
              onAdd={addRechargeToCart}
              isBtnLoading={isBtnLoading}
            />
          )}

          {isEditSalePriceModelOpen && (
            <UpdatePrice
              data={isEditSalePriceData}
              preSaleId={preSaleId}
              addToCart={addProductToCart}
              onClose={editSalePriceClose}
              customerSearchTerm={customerSearchTerm}
              customerSuggestions={customerSuggestions}
              highlightedIndex={highlightedIndex}
              showCustomerDropdown={showCustomerDropdown}
              selectedCustomer={selectedCustomer}
              suggestionRefs={suggestionRefs}
              customerSuggestionsRef={customerSuggestionsRef}
              handleCustomerSearch={handleCustomerSearch}
              handleSelectCustomer={handleSelectCustomer}
              handleCustomerKeyDown={handleCustomerKeyDown}
              handleKeyPress={handleKeyPress}
              setShowCustomerDropdown={setShowCustomerDropdown}
              onQuantityChanged={handleQuantityChanged}
              // noteSuggests={noteSuggest}
              // brandSuggest={brandSuggest}
              // setBrandSuggest={setBrandSuggest}
            />
          )}

          {isEditStockPriceData && (
            <FindStock
              data={isEditStockPriceData}
              recent={recentData}
              addToCart={addProductToCart}
              onClose={handleStockClose}
              offer={offerEnabled ? selectedOffer : null}
              customerSearchTerm={customerSearchTerm}
              customerSuggestions={customerSuggestions}
              highlightedIndex={highlightedIndex}
              showCustomerDropdown={showCustomerDropdown}
              selectedCustomer={selectedCustomer}
              suggestionRefs={suggestionRefs}
              customerSuggestionsRef={customerSuggestionsRef}
              handleCustomerSearch={handleCustomerSearch}
              handleSelectCustomer={handleSelectCustomer}
              handleCustomerKeyDown={handleCustomerKeyDown}
              handleKeyPress={handleKeyPress}
              setShowCustomerDropdown={setShowCustomerDropdown}
              // noteSuggests={noteSuggest}
              // brandSuggest={brandSuggest}
              // setBrandSuggest={setBrandSuggest}
            />
          )}

          {noteModalOpen && (
            <ProductNoteModal
              onClose={handleProductNoteClose}
              onSave={saveProductNote}
              initialNote={currentNoteProduct?.note || ""}
              noteSuggests={noteSuggest}
            />
          )}

          {isFavouriteProductModel && (
            <ListFavouriteProduct
              onClose={handleListFavouriteProductClose}
              handleAddClick={handleAddClick}
              listFavouriteProducts={favouriteProducts}
              loading={loading}
              favouriteProductsData={(updatedList) => {
                setFavouriteProducts(updatedList);
              }}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default Sale;
